"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9806],{

/***/ 55947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78678);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51042);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28769);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20979);



function InputNumber(param) {
    let { size ="md" , ...rest } = param;
    const { getInputProps , getIncrementButtonProps , getDecrementButtonProps  } = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useNumberInput */ .MM)(rest);
    const inc = getIncrementButtonProps();
    const dec = getDecrementButtonProps();
    const input = getInputProps();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .HStack */ .Ug, {
        spacing: 0,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                ...dec,
                variant: "outline",
                colorScheme: "gray",
                color: "gray.500",
                minW: size === "xs" ? "24px" : size === "sm" ? "24px" : "32px",
                p: size === "xs" ? "0 4px" : size === "sm" ? "0 6px" : "0 8px",
                h: size === "xs" ? "20px" : size === "sm" ? "24px" : "32px",
                fontSize: size === "xs" ? "10px" : size === "sm" ? "12px" : "14px",
                _hover: {
                    bg: "gray.50"
                },
                _disabled: {
                    opacity: 1,
                    cursor: "not-allowed"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Input */ .II, {
                ...input,
                borderLeft: 0,
                borderRight: 0,
                outline: "none !important",
                boxShadow: "none !important",
                _focus: {
                    boxShadow: "none !important"
                },
                textAlign: "center",
                h: size === "xs" ? "20px" : size === "sm" ? "24px" : "32px",
                fontSize: size === "xs" ? "12px" : size === "sm" ? "14px" : "16px",
                px: 0,
                minW: "25px"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                ...inc,
                variant: "outline",
                colorScheme: "gray",
                color: "gray.500",
                minW: size === "xs" ? "24px" : size === "sm" ? "24px" : "32px",
                p: size === "xs" ? "0 4px" : size === "sm" ? "0 6px" : "0 8px",
                h: size === "xs" ? "20px" : size === "sm" ? "24px" : "32px",
                fontSize: size === "xs" ? "10px" : size === "sm" ? "12px" : "14px",
                _hover: {
                    bg: "gray.50"
                },
                _disabled: {
                    opacity: 1,
                    cursor: "not-allowed"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 74046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




function UtilPriceFormatter(param) {
    let { prefix ="฿" , suffix ="" , price =0 , format ="0,0"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: prefix ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                    as: "span",
                    children: prefix
                }),
                numeral__WEBPACK_IMPORTED_MODULE_1___default()(price).format(format)
            ]
        }) : suffix ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                numeral__WEBPACK_IMPORTED_MODULE_1___default()(price).format(format),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                    as: "span",
                    children: suffix
                })
            ]
        }) : numeral__WEBPACK_IMPORTED_MODULE_1___default()(price).format(format)
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (UtilPriceFormatter);


/***/ }),

/***/ 83022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCart; }
/* harmony export */ });
/* harmony import */ var interfaces_promotion_interface__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42819);
/* harmony import */ var interfaces_user_interface__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15212);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var store_cart_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39098);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8100);
/* harmony import */ var _useShop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28801);
/* harmony import */ var _useUser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42409);
/* harmony import */ var respository_cart_repository__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61015);








function useCart() {
    let cartProp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var _cart_items;
    const { user , userPrimaryAddress , userAddresses  } = (0,_useUser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const { shippingMethodAvailable  } = (0,_useShop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const cart = (0,store_cart_store__WEBPACK_IMPORTED_MODULE_3__/* .useCartStore */ .x)((state)=>state.cart);
    // set cart to store
    const setCart = (0,store_cart_store__WEBPACK_IMPORTED_MODULE_3__/* .useCartStore */ .x)((state)=>state.setCart);
    const setQuantity = (0,store_cart_store__WEBPACK_IMPORTED_MODULE_3__/* .useCartStore */ .x)((state)=>state.setQuantity);
    const isInitialMount = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(true);
    const { data: cartData , error: cartError , mutate: cartMutate  } = (0,swr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(user && user.accessToken ? {
        url: "".concat("https://api.lamptan.co.th", "/v1/public/cart"),
        method: "GET",
        headers: {
            Authorization: "Bearer ".concat(user.accessToken)
        }
    } : null);
    // cart formatted
    const cartFormatted = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cart) {
            var _cart_items;
            const _cart = {
                ...cart,
                items: (_cart_items = cart.items) === null || _cart_items === void 0 ? void 0 : _cart_items.map((item)=>{
                    const weight = item.weight ? item.weight : 0;
                    // calculate weight total and round to 2 decimal places
                    const weightTotal = Math.round(weight * item.quantity);
                    const _item = {
                        ...item,
                        weight: item.weight ? item.weight : 0,
                        selected: item.selected ? item.selected : false,
                        subTotal: item.price * item.quantity,
                        weightTotal: weightTotal,
                        maxQuantity: (()=>{
                            var _item_product_variations;
                            if (user === null || user === void 0 ? void 0 : user.isAuthenticated) {
                                return item.maxQuantity;
                            }
                            if (item.variation) {
                                return item.variation.stockQuantity;
                            }
                            if (item.variationId && ((_item_product_variations = item.product.variations) === null || _item_product_variations === void 0 ? void 0 : _item_product_variations.length)) {
                                const selectedVariation = item.product.variations.find((variation)=>variation.id === item.variationId);
                                var _selectedVariation_stockQuantity;
                                return (_selectedVariation_stockQuantity = selectedVariation === null || selectedVariation === void 0 ? void 0 : selectedVariation.stockQuantity) !== null && _selectedVariation_stockQuantity !== void 0 ? _selectedVariation_stockQuantity : 1;
                            }
                            if (item.product.stockQuantity) {
                                return item.product.stockQuantity;
                            }
                            return 1;
                        })()
                    };
                    return _item;
                }),
                shippingMethodId: cart.shippingMethodId ? cart.shippingMethodId : 3
            };
            ;
            return _cart;
        }
        return null;
    }, [
        cart
    ]);
    // get cart items selected
    const cartItemsSelected = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cart) {
            var _cart_items;
            return (_cart_items = cart.items) === null || _cart_items === void 0 ? void 0 : _cart_items.filter((item)=>item.selected);
        }
        return [];
    }, [
        cart
    ]);
    // get cart total quantity
    const cartTotalQuantity = cart ? (_cart_items = cart.items) === null || _cart_items === void 0 ? void 0 : _cart_items.filter((item)=>item.selected).reduce((acc, item)=>acc + item.quantity, 0) : 0;
    // get cart total weight
    const cartWeightTotal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cartFormatted) {
            var _cartFormatted_items;
            const _totalWeight = (_cartFormatted_items = cartFormatted.items) === null || _cartFormatted_items === void 0 ? void 0 : _cartFormatted_items.filter((item)=>item.selected).reduce((acc, item)=>acc + item.weight * item.quantity, 0);
            // add 30% of total weight
            const _total = _totalWeight + _totalWeight * 0.3;
            // round to 2 decimal places
            return Math.round(_total);
        }
        return 0;
    }, [
        cartFormatted
    ]);
    // get cart total weight without 30% added
    const cartWeightTotalWithoutAdded = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cartFormatted) {
            var _cartFormatted_items;
            return (_cartFormatted_items = cartFormatted.items) === null || _cartFormatted_items === void 0 ? void 0 : _cartFormatted_items.filter((item)=>item.selected).reduce((acc, item)=>acc + item.weight * item.quantity, 0);
        }
        return 0;
    }, [
        cartFormatted
    ]);
    // get cart total shipping
    const cartShippingTotal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cartWeightTotal && (cartFormatted === null || cartFormatted === void 0 ? void 0 : cartFormatted.shippingMethodId) && shippingMethodAvailable) {
            const shippingMethod = shippingMethodAvailable === null || shippingMethodAvailable === void 0 ? void 0 : shippingMethodAvailable.find((method)=>method.id === cartFormatted.shippingMethodId);
            if (shippingMethod) {
                const rates = shippingMethod.rates;
                // find the rate
                const rate = rates === null || rates === void 0 ? void 0 : rates.find((rate)=>{
                    if (rate.minWeight && rate.maxWeight) {
                        return cartWeightTotal >= rate.minWeight && cartWeightTotal <= rate.maxWeight;
                    } else if (rate.minWeight) {
                        return cartWeightTotal >= rate.minWeight;
                    } else if (rate.maxWeight) {
                        return cartWeightTotal <= rate.maxWeight;
                    }
                    return false;
                });
                // find maxWeight
                const maxWeight = rates === null || rates === void 0 ? void 0 : rates.reduce((acc, rate)=>{
                    if (rate.maxWeight) {
                        return rate.maxWeight > acc ? rate.maxWeight : acc;
                    }
                    return acc;
                }, 0);
                if (maxWeight) {
                    const maxWeightRate = rates === null || rates === void 0 ? void 0 : rates.find((rate)=>rate.maxWeight === maxWeight);
                    // if cartWeightTotal > maxWeight
                    if (cartWeightTotal > maxWeight && maxWeightRate) {
                        return maxWeightRate.finalPrice;
                    }
                }
                if (rate) {
                    return rate.finalPrice;
                }
            } else {
                return 0;
            }
        } else if ((cartFormatted === null || cartFormatted === void 0 ? void 0 : cartFormatted.shippingTotal) && shippingMethodAvailable) {
            return cartFormatted === null || cartFormatted === void 0 ? void 0 : cartFormatted.shippingTotal;
        }
    }, [
        cartWeightTotal,
        cartFormatted,
        shippingMethodAvailable
    ]);
    // get cart total
    const cartTotal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cartFormatted && cartShippingTotal) {
            var _cartFormatted_items;
            const _total = (_cartFormatted_items = cartFormatted.items) === null || _cartFormatted_items === void 0 ? void 0 : _cartFormatted_items.filter((item)=>item.selected).reduce((acc, item)=>acc + item.subTotal, 0);
            const totalFormatted = _total + cartShippingTotal;
            // Check if cart has discount
            // If cart has discount, return subTotal - discount
            if (cartFormatted.discountTotal > 0) {
                return totalFormatted - cartFormatted.discountTotal;
            }
            return Math.floor(totalFormatted);
        }
        return 0;
    }, [
        cartFormatted,
        cartShippingTotal
    ]);
    // get cart sub total
    const cartSubTotal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cartFormatted) {
            var _cartFormatted_items;
            const subTotal = (_cartFormatted_items = cartFormatted.items) === null || _cartFormatted_items === void 0 ? void 0 : _cartFormatted_items.filter((item)=>item.selected).reduce((acc, item)=>acc + item.subTotal, 0);
            return subTotal;
        }
        return 0;
    }, [
        cartFormatted
    ]);
    // coupon-only discount total (ส่วนลดคูปอง)
    const cartCouponDiscountTotal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        var _cartFormatted_couponDiscountTotal;
        return (_cartFormatted_couponDiscountTotal = cartFormatted === null || cartFormatted === void 0 ? void 0 : cartFormatted.couponDiscountTotal) !== null && _cartFormatted_couponDiscountTotal !== void 0 ? _cartFormatted_couponDiscountTotal : 0;
    }, [
        cartFormatted
    ]);
    // bill-end discount total (ส่วนลดท้ายบิล), from PERCENTAGE_OFF promotions
    const cartBillDiscountTotal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        var _cartFormatted_percentageOffsPromotionsDiscountTotal;
        return (_cartFormatted_percentageOffsPromotionsDiscountTotal = cartFormatted === null || cartFormatted === void 0 ? void 0 : cartFormatted.percentageOffsPromotionsDiscountTotal) !== null && _cartFormatted_percentageOffsPromotionsDiscountTotal !== void 0 ? _cartFormatted_percentageOffsPromotionsDiscountTotal : 0;
    }, [
        cartFormatted
    ]);
    // active bill-discount promotions (name + headline + tiers) for the promo card
    const cartBillDiscountPromotions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        var _cartFormatted_billDiscountPromotions;
        return (_cartFormatted_billDiscountPromotions = cartFormatted === null || cartFormatted === void 0 ? void 0 : cartFormatted.billDiscountPromotions) !== null && _cartFormatted_billDiscountPromotions !== void 0 ? _cartFormatted_billDiscountPromotions : [];
    }, [
        cartFormatted
    ]);
    // next bill-discount tier the customer hasn't reached yet — used to render an
    // upsell hint ("spend X more for Y off"). null when no higher tier exists.
    const cartBillDiscountNextTier = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        const tiers = cartFormatted === null || cartFormatted === void 0 ? void 0 : cartFormatted.billDiscountTiers;
        if (!tiers || tiers.length === 0) {
            return null;
        }
        // tiers arrive sorted ascending by threshold; pick the lowest one above subtotal
        const nextTier = tiers.find((tier)=>tier.threshold > cartSubTotal);
        if (!nextTier) {
            return null;
        }
        var _nextTier_discountType;
        return {
            remaining: nextTier.threshold - cartSubTotal,
            threshold: nextTier.threshold,
            discountValue: nextTier.discountValue,
            discountType: (_nextTier_discountType = nextTier.discountType) !== null && _nextTier_discountType !== void 0 ? _nextTier_discountType : interfaces_promotion_interface__WEBPACK_IMPORTED_MODULE_0__/* .PromotionDiscountTypeEnum.FIXED */ .p.FIXED
        };
    }, [
        cartFormatted,
        cartSubTotal
    ]);
    // get cart items is all selected
    const cartIsAllSelected = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cart) {
            var _cart_items;
            return (_cart_items = cart.items) === null || _cart_items === void 0 ? void 0 : _cart_items.every((item)=>item.selected);
        }
        return false;
    }, [
        cart
    ]);
    // get cart items is intermediate selected
    const cartIsInterMediateSelected = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cart) {
            var _cart_items, _cart_items1;
            return ((_cart_items = cart.items) === null || _cart_items === void 0 ? void 0 : _cart_items.some((item)=>item.selected)) && !((_cart_items1 = cart.items) === null || _cart_items1 === void 0 ? void 0 : _cart_items1.every((item)=>item.selected));
        }
        return false;
    }, [
        cart
    ]);
    // get cart items selected count
    const cartSelectedCount = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cart) {
            var _cart_items;
            return (_cart_items = cart.items) === null || _cart_items === void 0 ? void 0 : _cart_items.filter((item)=>item.selected).length;
        }
        return 0;
    }, [
        cart
    ]);
    // get shipping address
    const cartShippingAddress = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cart === null || cart === void 0 ? void 0 : cart.shippingAddress) {
            return cart.shippingAddress;
        } else if (userPrimaryAddress) {
            return userPrimaryAddress;
        } else {
            if (userAddresses && userAddresses.length > 0) {
                return userAddresses[0];
            }
        }
        return null;
    }, [
        cart,
        userPrimaryAddress,
        userAddresses
    ]);
    // get shipping address need billing
    const cartShippingAddressHasTaxInvoice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (!cartShippingAddress) return false;
        return cartShippingAddress.taxInvoiceType === interfaces_user_interface__WEBPACK_IMPORTED_MODULE_1__/* .UserTaxInvoiceTypeEnum.INDIVIDUAL */ .jZ.INDIVIDUAL && cartShippingAddress.taxInvoiceId || cartShippingAddress.taxInvoiceType === interfaces_user_interface__WEBPACK_IMPORTED_MODULE_1__/* .UserTaxInvoiceTypeEnum.COMPANY */ .jZ.COMPANY && cartShippingAddress.taxInvoiceCompanyName ? true : false;
    }, [
        cartShippingAddress
    ]);
    // get billing address
    const cartBillingAddress = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cart === null || cart === void 0 ? void 0 : cart.billingAddress) {
            return cart.billingAddress;
        }
        return null;
    }, [
        cart
    ]);
    // get cart billing address formatted
    const cartBillingAddressFormatted = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (cartBillingAddress) {
            return cartBillingAddress ? "".concat(cartBillingAddress.address, " ").concat(cartBillingAddress.street, " ").concat(cartBillingAddress.subDistrict, ", ").concat(cartBillingAddress.district, ", ").concat(cartBillingAddress.province, ", ").concat(cartBillingAddress.postalCode) : "";
        }
        return "";
    }, [
        cartBillingAddress
    ]);
    // get cart from local storage
    /* useEffect(() => {
    if (!user?.isAuthenticated) {
      const _cart = localStorage.getItem('cart');
      if (_cart) {
        setCart(JSON.parse(_cart));
      }
    }
  }, [user]); */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (cartProp) {
            setCart({
                ...cartProp
            });
        }
    }, [
        cartProp
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (cartData) {
            setCart({
                ...cartData
            });
        }
    }, [
        cartData
    ]);
    // set cart to local storage
    const cartUpdate = (cart)=>{
        ;
        setCart({
            ...cart
        });
    // localStorage.setItem('cart', JSON.stringify(cart));
    };
    // update quantity of cart item
    const cartItemQuantityUpdate = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((key, quantity)=>{
        if (cart) {
            setQuantity(key, quantity);
        } else {
            ;
        }
    }, [
        cart
    ]);
    // select cart item
    const cartItemSelect = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((key, selected)=>{
        if (cart) {
            const newCart = {
                ...cart,
                items: cart === null || cart === void 0 ? void 0 : cart.items.map((item)=>{
                    if (item.key === key) {
                        return {
                            ...item,
                            selected
                        };
                    }
                    return item;
                })
            };
            cartUpdate(newCart);
        }
    }, [
        cart
    ]);
    // select all cart items
    const cartItemSelectAll = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((selected)=>{
        if (cart) {
            const newCart = {
                ...cart,
                items: cart === null || cart === void 0 ? void 0 : cart.items.map((item)=>{
                    return {
                        ...item,
                        selected
                    };
                })
            };
            cartUpdate(newCart);
        }
    }, [
        cart
    ]);
    // remove cart item
    const cartItemDelete = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((key)=>{
        if (cart) {
            var _cart_items;
            const newCart = {
                ...cart,
                items: cart === null || cart === void 0 ? void 0 : (_cart_items = cart.items) === null || _cart_items === void 0 ? void 0 : _cart_items.filter((item)=>item.key !== key)
            };
            // if cart items is empty, remove cart from local storage
            if (newCart.items.length === 0) {
                cartClear();
            } else {
                cartUpdate(newCart);
            }
        }
    }, [
        cart
    ]);
    // cart set shipping method
    const cartSetShippingMethod = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((shippingMethodId)=>{
        if (cart) {
            const newCart = {
                ...cart,
                shippingMethodId: shippingMethodId
            };
            cartUpdate(newCart);
        }
    }, [
        cart
    ]);
    // remove cart
    const cartClear = ()=>{
        localStorage.removeItem("cart");
        setCart(null);
    };
    const updateCartItemsToServer = async (cartItemsNotInCartFormatted)=>{
        try {
            for (const item of cartItemsNotInCartFormatted){
                var _item_attributeOptions;
                ;
                var _item_variationId;
                await respository_cart_repository__WEBPACK_IMPORTED_MODULE_7__/* .CartRepository.addOrUpdateItemToCart */ .e.addOrUpdateItemToCart({
                    key: item.key,
                    productId: item.product.id,
                    variationId: (_item_variationId = item.variationId) !== null && _item_variationId !== void 0 ? _item_variationId : undefined,
                    quantity: item.quantity,
                    attributeOptionIds: item.variationId && item.attributeOptions ? (_item_attributeOptions = item.attributeOptions) === null || _item_attributeOptions === void 0 ? void 0 : _item_attributeOptions.map((option)=>option.id) : []
                });
            }
        } catch (error) {
            ;
        // You might want to handle the error here, e.g., show a notification to the user
        }
    };
    // compare cart between local storage and server if user is authenticated
    // if cart is different item, update cart to server
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((user === null || user === void 0 ? void 0 : user.isAuthenticated) && cartData && cart) {
            if (cartData) {
                // find cart item that is not in cartFormatted
                const cartItemsNotInCartFormatted = cart === null || cart === void 0 ? void 0 : cart.items.filter((item)=>!cartData.items.some((x)=>x.key === item.key));
                // if cart items not in cartFormatted, update cart to server
                if (cartItemsNotInCartFormatted && cartItemsNotInCartFormatted.length > 0) {
                    updateCartItemsToServer(cartItemsNotInCartFormatted);
                }
            }
        }
    }, [
        user,
        cart,
        cartData
    ]);
    return {
        cart: cartFormatted,
        cartIsLoading: !cartError && !cartData,
        cartItemsSelected,
        cartTotalQuantity,
        cartIsAllSelected,
        cartIsInterMediateSelected,
        cartSelectedCount,
        cartTotal,
        cartSubTotal,
        cartCouponDiscountTotal,
        cartBillDiscountTotal,
        cartBillDiscountNextTier,
        cartBillDiscountPromotions,
        cartWeightTotal,
        cartWeightTotalWithoutAdded,
        cartShippingTotal,
        cartShippingAddress,
        cartShippingAddressHasTaxInvoice,
        cartBillingAddress,
        cartBillingAddressFormatted,
        cartMutate,
        cartUpdate,
        cartItemQuantityUpdate,
        cartClear,
        cartItemSelect,
        cartItemSelectAll,
        cartItemDelete,
        cartSetShippingMethod
    };
}


/***/ }),

/***/ 65633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26855);

function useCatchError() {
    const errorMessage = (error)=>{
        if (error) {
            if (error.response) {
                var _error_response_data, _error_response_data1, _error_response_data2;
                ;
                const _message = Array.isArray((_error_response_data = error.response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) ? (_error_response_data1 = error.response.data) === null || _error_response_data1 === void 0 ? void 0 : _error_response_data1.message[0] : (_error_response_data2 = error.response.data) === null || _error_response_data2 === void 0 ? void 0 : _error_response_data2.message;
                let messageFormatted = _message;
                antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error({
                    message: "พบข้อผิดพลาด",
                    description: messageFormatted
                });
            } else if (error.request) {
                ;
                antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error({
                    message: "พบข้อผิดพลาด",
                    description: error.message
                });
            } else {
                ;
                let messageFormatted1 = error.message;
                if (error.message === "invalid base-58 value") {
                    messageFormatted1 = "You private key is invalid";
                }
                antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error({
                    message: "พบข้อผิดพลาด",
                    description: error.message
                });
            }
        }
    };
    return errorMessage;
}
/* harmony default export */ __webpack_exports__["Z"] = (useCatchError);


/***/ }),

/***/ 88062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductCategories; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);

function useProductCategories() {
    let includeMainCategories = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // get all product categories
    const { data: productCategoriesData , error: isProductCategoriesError  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("".concat("https://api.lamptan.co.th", "/v1/public/product-categories?limit=500").concat(includeMainCategories ? "&include=mainCategory" : ""), {
        revalidateOnFocus: false,
        refreshInterval: 1000 * 60 * 5
    });
    // get product categories tree
    const { data: productCategoriesTreeData , error: productCategoriesTreeError  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("".concat("https://api.lamptan.co.th", "/v1/public/product-categories/tree"), {
        revalidateOnFocus: false,
        refreshInterval: 1000 * 60 * 5
    });
    return {
        productCategoriesLoading: !productCategoriesData && !isProductCategoriesError,
        productCategories: (productCategoriesData === null || productCategoriesData === void 0 ? void 0 : productCategoriesData.docs) || [],
        productCategoryTreeLoading: !productCategoriesTreeData && !productCategoriesTreeError,
        productCategoryTree: productCategoriesTreeData || []
    };
}


/***/ }),

/***/ 58696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductCategoriesArchive; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17563);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _useCatchError__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65633);
/* harmony import */ var _useProductCategories__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88062);
/* harmony import */ var _useProductMainCategories__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68758);







function useProductCategoriesArchive() {
    // use catch error hook
    const catchError = (0,_useCatchError__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    // use router
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { permalink  } = router.query;
    ;
    // get all product categories
    const { productCategories , productCategoryTree  } = (0,_useProductCategories__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(true);
    // get product main categories
    const { productMainCategories  } = (0,_useProductMainCategories__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    // init breadcrumb
    const [breadcrumb, setBreadcrumb] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    // init product categories selected
    const [productCategoriesSelected, setProductCategoriesSelected] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    // init current parent category
    const [currentParentCategory, setCurrentParentCategory] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null);
    // init current category index
    const [currentParentCategoryIndexes, setCurrentParentCategoryIndexes] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([
        0
    ]);
    // init current category selected ids
    const [currentCategorySelectedIds, setCurrentCategorySelectedIds] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    // get productCategories tree for lighting
    const productCategoriesTreeForLighting = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        if (productCategoryTree && productCategoryTree.length > 0) {
            return productCategoryTree.map((category)=>{
                var _category_children;
                return {
                    ...category,
                    children: (_category_children = category.children) === null || _category_children === void 0 ? void 0 : _category_children.filter((child)=>child.mainCategoryId === 1),
                    mainCategory: productMainCategories.find((mainCategory)=>mainCategory.id === category.mainCategoryId)
                };
            });
        }
    }, [
        productCategories,
        productCategoryTree,
        productMainCategories
    ]);
    ;
    // get productCategories tree for smart-home
    const productCategoriesTreeForSmartHome = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        return productCategories.filter((category)=>category.mainCategoryId === 2 // 2 is mainCategoryId of smart-home
        );
    }, [
        productCategories
    ]);
    // get productCategories tree for decoration-lamp
    const productCategoriesTreeForDecorationLampStyle = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        return productCategories.filter((category)=>category.mainCategoryId === 3 // 3 is mainCategoryId of decoration-lamp
        ).filter((category)=>category.permalink.startsWith("type/")); // 1 is parentId of type
    }, [
        productCategories
    ]);
    // get productCategories tree for decoration-lamp
    const productCategoriesTreeForDecorationLampFunction = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        return productCategories.filter((category)=>category.mainCategoryId === 3 // 3 is mainCategoryId of decoration-lamp
        ).filter((category)=>category.permalink.startsWith("function/")); // 2 is parentId of function
    }, [
        productCategories,
        router.query
    ]);
    /**
   * ** Note **
   * Get current parent category
   *
   * Expected result:
   * 1. If permalink is not empty, then find current parent category
   * 2. If permalink is empty, then set current parent category to null
   */ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (productCategoryTree && productCategoryTree.length > 0) {
            let permalinkString = "";
            if (Array.isArray(permalink)) {
                if (permalink.length > 0) {
                    if (permalink[0] === "lighting" || permalink[0] === "smart-home" || permalink[0] === "decoration-lamp") {
                        if (permalink.length > 1) {
                            permalinkString = permalink[1];
                        }
                    } else {
                        permalinkString = permalink[0];
                    }
                }
            } else if (permalink) {
                permalinkString = permalink.toString();
            }
            ;
            // find current parent category
            const _currentParentCategory = productCategoryTree.find((category)=>category.permalink === permalinkString);
            ;
            if (_currentParentCategory) {
                setCurrentParentCategory(_currentParentCategory);
            } else {
                setCurrentParentCategory(null);
            }
        }
    }, [
        permalink,
        productCategoryTree
    ]);
    // get current category
    const currentCategory = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        // set permalink
        if (permalink && permalink.length > 0 && productCategories) {
            const permalinkWithSlash = Array.isArray(permalink) ? permalink.slice(-2).join("/") : permalink;
            ;
            // find productCategories by lastPermalink
            const _currentCategory = productCategories.find((category)=>category.permalink === permalinkWithSlash);
            ;
            return _currentCategory;
        }
    }, [
        permalink,
        productCategories
    ]);
    /**
   * ** Note **
   * Handle when query change
   *
   * Expected result:
   * 1. If categoryIds is not empty, then set currentCategorySelectedIds to categoryIds
   * 2. If categoryIds is empty, then set currentCategorySelectedIds to []
   */ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (router.query) {
            ;
            if (router.query.categoryIds) {
                const categoryIds = Array.isArray(router.query.categoryIds) ? router.query.categoryIds : router.query.categoryIds.toString().split(",");
                ;
                // convert category ids to number
                const categoryIdsNumber = categoryIds.map((categoryId)=>Number(categoryId));
                ;
                setCurrentCategorySelectedIds(categoryIdsNumber);
            } else {
                setCurrentCategorySelectedIds([]);
            }
        }
    }, [
        router.query
    ]);
    /**
   * ** Note **
   * Handle category selected
   *
   * Expectation:
   * 1. If checked, add id to current category selected ids
   * 2. If unchecked, remove id from current category selected ids
   * 3. Push query to router
   *
   */ const handleCategorySelected = function(e) {
        let isRouterPush = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const queryParse = query_string__WEBPACK_IMPORTED_MODULE_2__.parseUrl(window.location.href);
        // if checked
        if (e.target.checked) {
            const _currentCategorySelectedIds = [
                ...currentCategorySelectedIds,
                Number(e.target.value)
            ];
            // add id to current category selected ids
            setCurrentCategorySelectedIds(_currentCategorySelectedIds);
            if (isRouterPush) {
                // push query to router
                router.push("".concat(queryParse.url, "?").concat(query_string__WEBPACK_IMPORTED_MODULE_2__.stringify({
                    ...queryParse.query,
                    categoryIds: _currentCategorySelectedIds.join(","),
                    page: 1
                })), undefined, {
                    shallow: true
                });
            }
        } else {
            // remove id from current category selected ids
            const _currentCategorySelectedIds1 = currentCategorySelectedIds.filter((id)=>id !== Number(e.target.value));
            setCurrentCategorySelectedIds(_currentCategorySelectedIds1);
            const _currentCategorySelectedIdsString = _currentCategorySelectedIds1.join(",");
            if (isRouterPush) {
                // push query to router
                router.push("".concat(queryParse.url, "?").concat(query_string__WEBPACK_IMPORTED_MODULE_2__.stringify({
                    ...queryParse.query,
                    categoryIds: _currentCategorySelectedIds1.length > 0 ? _currentCategorySelectedIdsString === "" ? undefined : _currentCategorySelectedIdsString : undefined,
                    page: 1
                })), undefined, {
                    shallow: true
                });
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        /**
     * ** Note **
     * if productCategoriesSelected we will find index of productCategoryTree
     * that match with productCategoriesSelected parent id
     * then we will set currentParentCategoryIndexes to that index
     *
     * Expectation: currentParentCategoryIndexes will be [0, 1]
     */ if (productCategoriesSelected && productCategoriesSelected.length > 0 && productCategoryTree && productCategoryTree.length > 0) {
            ;
            // find index of productCategoryTree that match with productCategoriesSelected parent id
            const _productCategoryTreeIndexs = productCategoryTree.map((category)=>{
                if (productCategoriesSelected.find((c)=>c.parentId === category.id)) {
                    return productCategoryTree.findIndex((c2)=>c2.id === category.id);
                }
            });
            ;
            const _currentParentCategoryIndexes = _productCategoryTreeIndexs.filter((index)=>index !== undefined);
            if (_currentParentCategoryIndexes.length > 0) {
                setCurrentParentCategoryIndexes(_currentParentCategoryIndexes);
            }
        } else {
            if (currentParentCategory) {
                ;
                // find current category index
                const currentParentCategoryIndexes = productCategoryTree.findIndex((category)=>category.id === currentParentCategory.id);
                if (currentParentCategoryIndexes !== -1) {
                    setCurrentParentCategoryIndexes([
                        currentParentCategoryIndexes
                    ]);
                } else {
                    setCurrentParentCategoryIndexes([
                        0
                    ]);
                }
            } else {
                setCurrentParentCategoryIndexes([
                    0
                ]);
            }
        }
    }, [
        productCategoriesSelected,
        currentParentCategory
    ]);
    // handle set product categories selected when router change
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        const handleRouteChange = async (url)=>{
            const queryParsed = query_string__WEBPACK_IMPORTED_MODULE_2__.parseUrl(url);
            ;
            const { query  } = queryParsed;
            try {
                if (query.categoryIds) {
                    const ids = query.categoryIds.toString().split(",").map((id)=>+id);
                    ;
                    if (productCategories) {
                        setProductCategoriesSelected(productCategories.filter((category)=>ids.includes(category.id)));
                    }
                } else {
                    setProductCategoriesSelected([]);
                }
            } catch (error) {
                catchError(error);
            }
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return ()=>{
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router
    ]);
    // handle set product categories selected ids when initial load
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (router.query.categoryIds && router.query.categoryIds.length > 0 && productCategories && !productCategoriesSelected.length // do not set productCategoriesSelected if it has value
        ) {
            const ids = router.query.categoryIds.toString().split(",").map((id)=>+id);
            setProductCategoriesSelected(productCategories.filter((category)=>ids.includes(category.id)));
        }
    }, [
        router,
        productCategories
    ]);
    // handle set current parent category index
    const handleSetCurrentParentCategoryIndexes = (index)=>{
        setCurrentParentCategoryIndexes(index);
    };
    /**
   * ** Note **
   * Clear filter will remove all query string except page
   *
   * Expectation: Remove categoryIds and sort query string
   */ const handleClearFilter = ()=>{
        const queryParsed = query_string__WEBPACK_IMPORTED_MODULE_2__.parseUrl(window.location.href);
        const { query  } = queryParsed;
        const queryFormatted = {
            ...query,
            page: 1,
            categoryIds: undefined,
            sort: undefined
        };
        // format query string
        const queryStringFormatted = query_string__WEBPACK_IMPORTED_MODULE_2__.stringify(queryFormatted);
        router.push("".concat(queryParsed.url, "?").concat(queryStringFormatted)).then(()=>window.scrollTo(0, 0));
    };
    // get my account layout breadcrumb
    const [layoutBreadcrumb, setLayoutBreadcrumb] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([
        {
            label: "หน้าแรก",
            href: "/"
        }
    ]);
    // create breadcrumb
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        ;
        const { permalink  } = router.query;
        let _breadcrumbs = [];
        ;
        // if permalink is array
        if (Array.isArray(permalink)) {
            // if first item is equal to 'lighting' or 'smart-home' or 'decoration-lamp'
            // remove first item
            if (permalink[0] === "lighting" || permalink[0] === "smart-home" || permalink[0] === "decoration-lamp") {
                // get main category by permalink[0]
                const mainCategory = productMainCategories.find((mainCategory)=>mainCategory.permalink === permalink[0]);
                // if mainCategory is not undefined
                if (mainCategory) {
                    // push mainCategory to _breadcrumbs
                    _breadcrumbs.push({
                        label: router.locale === "th" ? mainCategory.name_th : mainCategory.name_en,
                        href: "/product-categories/".concat(mainCategory.permalink)
                    });
                }
            }
            // loop through permalink array and get category by permalink
            permalink.forEach((permalink)=>{
                const category = productCategories.find((category)=>category.permalink === permalink);
                const mainCategory = productMainCategories.find((mainCategory)=>{
                    return mainCategory.id === (category === null || category === void 0 ? void 0 : category.mainCategoryId);
                });
                // if category is not undefined
                if (category) {
                    // push category to _breadcrumbs
                    _breadcrumbs.push({
                        label: router.locale === "th" ? category.name_th : category.name_en,
                        href: "/product-categories/".concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.permalink, "/").concat(category.permalink)
                    });
                }
            });
        }
        if (currentCategory) {
            // get main category by
            const mainCategory1 = productMainCategories.find((mainCategory)=>mainCategory.id === currentCategory.mainCategoryId);
            // if mainCategory is not undefined
            if (mainCategory1) {
                // prepend mainCategory to _breadcrumbs
                if (mainCategory1.permalink !== "lighting") {
                    _breadcrumbs.unshift({
                        label: router.locale === "th" ? mainCategory1.name_th : mainCategory1.name_en,
                        href: mainCategory1.permalink === "smart-home" ? "/product-categories/smart-home/?productType=smart-home" : mainCategory1.permalink === "decoration-lamp" ? "/product-categories/".concat(mainCategory1.permalink, "/?productType=decoration") : "/"
                    });
                }
                ;
                // push currentCategory to _breadcrumbs
                _breadcrumbs.push({
                    label: router.locale === "th" ? currentCategory.name_th : currentCategory.name_en,
                    href: ""
                });
            }
        }
        // remove duplicate breadcrumb
        _breadcrumbs = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.uniqBy)(_breadcrumbs, "href");
        _breadcrumbs = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.uniqBy)(_breadcrumbs, "label");
        if (_breadcrumbs.length > 0) {
            if ((currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.mainCategoryId) !== 1) {
                _breadcrumbs = _breadcrumbs.filter((breadcrumb)=>breadcrumb.href !== "/product-categories/lighting/type");
            }
        }
        // remove 2rd breadcrumb if it is '/product-categories/lighting/xxx'
        if (_breadcrumbs.length > 1) {
            if (_breadcrumbs[1].href.includes("/product-categories/lighting/")) {
                _breadcrumbs.splice(1, 1);
            }
        }
        ;
        // set breadcrumb
        setBreadcrumb(_breadcrumbs);
    }, [
        router,
        productMainCategories,
        productCategories,
        currentCategory
    ]);
    return {
        productCategories: productCategories || [],
        productCategoryTree: productCategoryTree,
        productCategoriesTreeForLighting,
        productCategoriesTreeForSmartHome,
        productCategoriesTreeForDecorationLampFunction,
        productCategoriesTreeForDecorationLampStyle,
        productCategoriesSelected,
        productCategoriesSelectedIds: currentCategorySelectedIds,
        currentParentCategory,
        currentParentCategoryIndexes,
        breadcrumb,
        handleCategorySelected,
        handleSetCurrentParentCategoryIndexes,
        handleClearFilter
    };
}


/***/ }),

/***/ 13043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductItem; }
/* harmony export */ });
/* harmony import */ var interfaces_product_interface__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75779);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function useProductItem(param) {
    let { product =null , variation =null  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const name = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (product) {
            if (router.locale === "en") {
                return product.name_en;
            } else {
                if (product.name_th) {
                    return product.name_th;
                } else {
                    return product.name_en;
                }
            }
        }
        return "NA";
    }, [
        product,
        router
    ]);
    const featuredImage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        let _featuredImage = "/image-icon/empty-image.png";
        if (variation) {
            if (variation.featuredImage) {
                // 1. variation's own dedicated featured image
                _featuredImage = "".concat("https://storage.lamptan.co.th", "/").concat(variation.featuredImage.name);
            } else if (variation.gallery && variation.gallery.length > 0) {
                // 2. fall back to the variation's gallery: prefer the image flagged
                // as featured in gallerySetting (sequence === 1), else the first one
                if (variation.gallerySetting) {
                    const featuredImageFromGallery = variation.gallery.find((gallery)=>{
                        var _variation_gallerySetting;
                        return (_variation_gallerySetting = variation.gallerySetting) === null || _variation_gallerySetting === void 0 ? void 0 : _variation_gallerySetting.some((gallerySetting)=>gallerySetting.mediaId === gallery.id && gallerySetting.sequence === 1);
                    });
                    if (featuredImageFromGallery) {
                        _featuredImage = "".concat("https://storage.lamptan.co.th", "/").concat(featuredImageFromGallery.name);
                    } else {
                        var _variation_gallery_;
                        _featuredImage = "".concat("https://storage.lamptan.co.th", "/").concat((_variation_gallery_ = variation.gallery[0]) === null || _variation_gallery_ === void 0 ? void 0 : _variation_gallery_.name);
                    }
                } else {
                    var _variation_gallery_1;
                    _featuredImage = "".concat("https://storage.lamptan.co.th", "/").concat((_variation_gallery_1 = variation.gallery[0]) === null || _variation_gallery_1 === void 0 ? void 0 : _variation_gallery_1.name);
                }
            } else if (product === null || product === void 0 ? void 0 : product.featuredImage) {
                // 3. final fallback to the parent product's featured image
                _featuredImage = "".concat("https://storage.lamptan.co.th", "/").concat(product.featuredImage.name);
            }
        } else {
            // For main product (not variation), use product's featured image
            if (product === null || product === void 0 ? void 0 : product.featuredImage) {
                _featuredImage = "".concat("https://storage.lamptan.co.th", "/").concat(product.featuredImage.name);
            }
        }
        return _featuredImage;
    }, [
        product,
        variation
    ]);
    const variationName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (product && variation) {
            // if variation has attributeOptions
            if (variation.attributeOptions && variation.attributeOptions.length > 0) {
                ;
                // get attributeOption name
                const attributeOptionNames = variation.attributeOptions.map((attributeOption)=>{
                    if (router.locale === "en") {
                        return attributeOption.name_en;
                    } else {
                        if (attributeOption.name_th) {
                            return attributeOption.name_th;
                        } else {
                            return attributeOption.name_en;
                        }
                    }
                });
                // join attributeOption name
                return attributeOptionNames.join(" ");
            }
        }
        return "";
    }, [
        product,
        variation,
        router
    ]);
    const variationNameWithAttributes = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (variation) {
            // if variation has attributeOptions
            if (variation.attributeOptions && variation.attributeOptions.length > 0) {
                // get attributeOption name
                const attributeOptionNames = variation.attributeOptions.map((attributeOption)=>{
                    if (attributeOption.productAttribute) {
                        if (router.locale === "en") {
                            return "".concat(attributeOption.productAttribute.name_en, ": ").concat(attributeOption.name_en);
                        } else {
                            return "".concat(attributeOption.productAttribute.name_th, ": ").concat(attributeOption.name_th);
                        }
                    } else {
                        return "";
                    }
                }).filter((attributeOptionName)=>attributeOptionName);
                return attributeOptionNames;
            }
        }
        return [];
    }, [
        variation,
        router
    ]);
    // formate product price
    const salePrice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (product) {
            const prices = [];
            if (product.customSalePrice && product.customSalePrice > 0) {
                prices.push(product.customSalePrice);
            }
            if (product.everydayPriceMin && product.everydayPriceMin > 0) {
                prices.push(product.everydayPriceMin);
            }
            if (product.everydayPrice && product.everydayPrice > 0 && product.everydayPriceAvailable) {
                prices.push(product.everydayPrice);
            }
            if (product.floorPriceMin && product.floorPriceMin > 0) {
                prices.push(product.floorPriceMin);
            }
            if (product.floorPrice && product.floorPrice > 0 && product.floorPriceAvailable) {
                prices.push(product.floorPrice);
            }
            ;
            if (prices.length > 0) {
                return Math.min(...prices);
            }
            return 0;
        }
        return 0;
    }, [
        product
    ]);
    const regularPrice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (product) {
            const prices = [];
            if (product.customRegularPrice && product.customRegularPrice > 0) {
                prices.push(product.customRegularPrice);
            }
            if (product.type === interfaces_product_interface__WEBPACK_IMPORTED_MODULE_0__/* .ProductTypeEnum.VARIATION */ .C.VARIATION) {
                if (product.claimedPriceMin && product.claimedPriceMin > 0) {
                    prices.push(product.claimedPriceMin);
                }
            } else {
                if (product.claimedPrice && product.claimedPrice > 0) {
                    prices.push(product.claimedPrice);
                }
            }
            if (prices.length > 0) {
                return Math.min(...prices);
            }
            return 0;
        }
        return 0;
    }, [
        product
    ]);
    const savingPrice = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (regularPrice > 0 && salePrice > 0) {
            const saving = regularPrice - salePrice;
            return Math.abs(saving);
        }
        return 0;
    }, [
        regularPrice,
        salePrice
    ]);
    return {
        product,
        featuredImage,
        name,
        variationName,
        variationNameWithAttributes,
        savingPrice,
        regularPrice,
        salePrice
    };
}


/***/ }),

/***/ 68758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductMainCategories; }
/* harmony export */ });
/* harmony import */ var swr_immutable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49770);

function useProductMainCategories() {
    // get all product categories
    const { data: productMainCategoriesData  } = (0,swr_immutable__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("".concat("https://api.lamptan.co.th", "/v1/public/product-main-categories?limit=100"));
    return {
        productMainCategories: (productMainCategoriesData === null || productMainCategoriesData === void 0 ? void 0 : productMainCategoriesData.docs) || []
    };
}


/***/ }),

/***/ 28801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShop; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);


function useShop() {
    const { data: shippingMethodsData  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("".concat("https://api.lamptan.co.th", "/v1/public/shop/shipping-methods"));
    // get available shipping methods
    const shippingMethodAvailable = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        // ** NOTE: This is a fixed shipping method for first release
        // ** allow only EMS and REGISTERED
        if (shippingMethodsData) {
            return shippingMethodsData.docs.filter((method)=>method.active && (method.id === 1 || method.id === 3 // 1: EMS 3: REGISTERED
                )).map((method)=>{
                return {
                    ...method,
                    name_en: method.id === 1 ? "EMS" : method.id === 3 ? "REGISTER" : "",
                    name_th: method.id === 1 ? "EMS" : method.id === 3 ? "ลงทะเบียน" : ""
                };
            }).sort((a, b)=>b.id - a.id);
        }
        return [];
    }, [
        shippingMethodsData
    ]);
    return {
        shippingMethods: shippingMethodsData ? shippingMethodsData.docs : [],
        shippingMethodAvailable
    };
}


/***/ }),

/***/ 42409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useUser; }
});

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(70594);
// EXTERNAL MODULE: ./libs/axios.ts
var libs_axios = __webpack_require__(64232);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./interfaces/user.interface.ts
var user_interface = __webpack_require__(15212);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(64529);
;// CONCATENATED MODULE: ./store/user.store.ts


const useUserStore = (0,esm/* default */.ZP)((set)=>({
        user: {
            id: 0,
            firstName: "",
            lastName: "",
            email: "",
            mobileNumber: "",
            createdAt: new Date(),
            updatedAt: new Date(),
            isAuthenticated: false,
            accessToken: "",
            birthDate: null,
            gender: user_interface/* UserGenderEnum.OTHER */.qx.OTHER,
            passwordIsSet: false,
            passwordResetToken: null,
            addresses: [],
            status: user_interface/* UserStatusEnum.INACTIVE */.bv.INACTIVE
        },
        setUser: (payload)=>set({
                user: payload
            })
    }));

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./hooks/useUser.ts





function useUser(params) {
    const user = useUserStore((state)=>state.user);
    const setUser = useUserStore((state)=>state.setUser);
    const [loading, setLoading] = (0,react.useState)(true);
    const { data: userResponse , mutate: mutateUser  } = (0,dist/* default */.ZP)("/api/users/session");
    const updateUser = async (user)=>{
        setUser(user);
    };
    const logout = async ()=>{
        mutateUser(await axios/* default.post */.Z.post("/api/users/logout-session"), false);
        setUser(null);
    };
    (0,react.useEffect)(()=>{
        if (userResponse) {
            if (userResponse.accessToken) {
                // set axios token after login
                libs_axios/* default.defaults.headers.common.Authorization */.Z.defaults.headers.common.Authorization = "Bearer ".concat(userResponse.accessToken);
            }
            setUser(userResponse);
            setLoading(false);
        }
    }, [
        userResponse
    ]);
    (0,react.useEffect)(()=>{
        if (params === null || params === void 0 ? void 0 : params.user) {
            setUser(params.user);
            setLoading(false);
        }
    }, [
        params === null || params === void 0 ? void 0 : params.user
    ]);
    // get address
    const userAddresses = (0,react.useMemo)(()=>{
        if (user && user.addresses && user.addresses.length > 0) {
            return user.addresses;
        }
        return [];
    }, [
        user
    ]);
    // get primary address
    const userPrimaryAddress = (0,react.useMemo)(()=>{
        if (userAddresses && userAddresses.length > 0) {
            return userAddresses.find((address)=>address.isPrimaryAddress);
        }
        return null;
    }, [
        userAddresses
    ]);
    return {
        user,
        isAuthLoading: loading,
        userAddresses,
        userPrimaryAddress,
        mutateUser,
        updateUser,
        logout
    };
}


/***/ }),

/***/ 56395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWishlist; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var store_wishlist_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4295);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8100);
/* harmony import */ var _useUser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42409);




function useWishlist(query) {
    // use user
    const { user  } = (0,_useUser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    // use wish list store
    const { wishlists , wishlistsTotal , setWishlists , setWishlistsTotal  } = (0,store_wishlist_store__WEBPACK_IMPORTED_MODULE_1__/* .useWishlistStore */ .Y)();
    // get wishlists
    const { data: wishlistsData  } = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(()=>user && user.accessToken ? {
            url: "".concat("https://api.lamptan.co.th", "/v1/public/profile/wishlists").concat(query ? "?".concat(query) : ""),
            method: "GET",
            headers: {
                Authorization: "Bearer ".concat(user.accessToken)
            }
        } : null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        ;
        if (wishlistsData) {
            setWishlists(wishlistsData.docs);
            setWishlistsTotal(wishlistsData.totalDocs);
        }
    }, [
        wishlistsData
    ]);
    return {
        wishlistsData,
        wishlists,
        wishlistsTotal
    };
}


/***/ }),

/***/ 75779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ProductTypeEnum; },
/* harmony export */   "X": function() { return /* binding */ ProductStatusEnum; }
/* harmony export */ });
var ProductStatusEnum;
(function(ProductStatusEnum) {
    ProductStatusEnum["DRAFT"] = "DRAFT";
    ProductStatusEnum["PUBLISHED"] = "PUBLISHED";
    ProductStatusEnum["INACTIVE"] = "INACTIVE";
    ProductStatusEnum["PENDING"] = "PENDING";
    ProductStatusEnum["SCHEDULED"] = "SCHEDULED";
    ProductStatusEnum["DELETING"] = "DELETING";
})(ProductStatusEnum || (ProductStatusEnum = {}));
var ProductTypeEnum;
(function(ProductTypeEnum) {
    ProductTypeEnum["SIMPLE"] = "SIMPLE";
    ProductTypeEnum["VARIATION"] = "VARIATION";
})(ProductTypeEnum || (ProductTypeEnum = {}));


/***/ }),

/***/ 42819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ PromotionTypeEnum; },
/* harmony export */   "p": function() { return /* binding */ PromotionDiscountTypeEnum; }
/* harmony export */ });
var PromotionTypeEnum;
(function(PromotionTypeEnum) {
    PromotionTypeEnum["COUPON"] = "COUPON";
    PromotionTypeEnum["BUY1_GET1"] = "BUY1_GET1";
    PromotionTypeEnum["BUYX_GETX"] = "BUYX_GETX";
    PromotionTypeEnum["PERCENTAGE_OFF"] = "PERCENTAGE_OFF";
})(PromotionTypeEnum || (PromotionTypeEnum = {}));
var PromotionDiscountTypeEnum;
(function(PromotionDiscountTypeEnum) {
    PromotionDiscountTypeEnum["PERCENTAGE"] = "PERCENTAGE";
    PromotionDiscountTypeEnum["FIXED"] = "FIXED";
})(PromotionDiscountTypeEnum || (PromotionDiscountTypeEnum = {}));


/***/ }),

/***/ 15212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bv": function() { return /* binding */ UserStatusEnum; },
/* harmony export */   "jZ": function() { return /* binding */ UserTaxInvoiceTypeEnum; },
/* harmony export */   "qx": function() { return /* binding */ UserGenderEnum; }
/* harmony export */ });
var UserStatusEnum;
(function(UserStatusEnum) {
    UserStatusEnum["ACTIVE"] = "ACTIVE";
    UserStatusEnum["INACTIVE"] = "INACTIVE";
    UserStatusEnum["SUSPENDED"] = "SUSPENDED";
})(UserStatusEnum || (UserStatusEnum = {}));
var UserGenderEnum;
(function(UserGenderEnum) {
    UserGenderEnum["MALE"] = "MALE";
    UserGenderEnum["FEMALE"] = "FEMALE";
    UserGenderEnum["OTHER"] = "OTHER";
})(UserGenderEnum || (UserGenderEnum = {}));
var UserTaxInvoiceTypeEnum;
(function(UserTaxInvoiceTypeEnum) {
    UserTaxInvoiceTypeEnum["INDIVIDUAL"] = "INDIVIDUAL";
    UserTaxInvoiceTypeEnum["COMPANY"] = "COMPANY";
})(UserTaxInvoiceTypeEnum || (UserTaxInvoiceTypeEnum = {}));


/***/ }),

/***/ 89806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_RootLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(80419);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js
var accordion_dist_index_esm = __webpack_require__(31937);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(35656);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/layouts/footer/LayoutFooterMenu.tsx




function LayoutFooterMenu(param) {
    let { menu  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
        spacing: 1,
        children: menu.map((item, index)=>{
            var _item_target;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: item.href,
                    passHref: true,
                    target: (_item_target = item.target) !== null && _item_target !== void 0 ? _item_target : "_self",
                    children: item.label
                })
            }, index);
        })
    });
}
/* harmony default export */ var footer_LayoutFooterMenu = (LayoutFooterMenu);

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./respository/newsletter.repository.ts
var newsletter_repository = __webpack_require__(70625);
;// CONCATENATED MODULE: ./components/layouts/footer/LayoutFooter.tsx









function LayoutFooter() {
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const toast = (0,dist_index_esm/* useToast */.pm)();
    const [isDesktop] = (0,media_query_dist_index_esm/* useMediaQuery */.ac)("(min-width: 992px)");
    // init current scroll position
    const [currentScrollPosition, setCurrentScrollPosition] = (0,react.useState)(0);
    // init current scroll height percentage
    const [currentScrollHeightPercentage, setCurrentScrollHeightPercentage] = (0,react.useState)(0);
    const [newsletterEmail, setNewsletterEmail] = (0,react.useState)("");
    const [isNewsletterLoading, setIsNewsletterLoading] = (0,react.useState)(false);
    // use router
    const router = (0,next_router.useRouter)();
    const { locale  } = router;
    const menu1 = (0,react.useMemo)(()=>{
        return [
            {
                label: t("layout.footer.menu1.howToOrder", {
                }),
                href: "/how-to-buy"
            },
            {
                label: t("layout.footer.menu1.paymentMethod", {
                }),
                href: "/how-to-pay"
            },
            {
                label: t("layout.footer.menu1.checkOrderStatus", {
                }),
                href: "/my-account/orders"
            },
            {
                label: t("layout.footer.menu1.shippingFee", {
                }),
                href: "/shipping-service-charge"
            },
            {
                label: t("layout.footer.menu1.returnsRefunds", {
                }),
                href: "/claim-replacement"
            },
            {
                label: t("layout.footer.menu1.warrantyPolicy", {
                }),
                href: "/warranty-policy"
            }
        ];
    }, [
        t
    ]);
    const menu2 = (0,react.useMemo)(()=>{
        return [
            {
                label: t("layout.footer.menu2.dealer", {
                }),
                href: "/agent"
            },
            {
                label: t("layout.footer.menu2.lbs", {
                }),
                href: "https://www.google.com/maps/place/Lamptan+Bright+Studio/@13.6658413,100.4543676,13.53z/data=!4m6!3m5!1s0x30e2a2c7f713dd09:0xfda95b6119a67588!8m2!3d13.6691411!4d100.4517272!16s%2Fg%2F11g6j7d2t5?entry=ttu",
                target: "_blank"
            }
        ];
    }, [
        t
    ]);
    const menu3 = (0,react.useMemo)(()=>{
        return [
            {
                label: t("layout.footer.menu3.aboutUs", {
                }),
                href: "/about-us"
            },
            {
                label: t("layout.footer.menu3.workWithUs", {
                }),
                href: "/careers"
            },
            {
                label: t("layout.footer.menu3.privacyPolicy", {
                }),
                href: "/privacy-policy"
            },
            {
                label: t("layout.footer.menu3.cookiePolicy", {
                }),
                href: "/cookie-policy"
            }
        ];
    }, [
        t
    ]);
    // handle scroll change
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            setCurrentScrollPosition(window.scrollY);
            // get window height
            const windowHeight = window.innerHeight;
            // get scrollable height
            const scrollableHeight = document.body.scrollHeight - windowHeight;
            // get scroll percentage
            const scrollPercentage = window.scrollY / scrollableHeight * 100;
            ;
            ;
            ;
            setCurrentScrollHeightPercentage(scrollPercentage);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    // log currentScrollPosition
    (0,react.useEffect)(()=>{
        ;
    }, [
        currentScrollPosition
    ]);
    const { data: contactUsTh  } = (0,dist/* default */.ZP)(locale === "th" ? {
        url: "".concat("https://api.lamptan.co.th", "/v1/settings/contactUsTh"),
        method: "GET"
    } : null);
    const { data: contactUsEn  } = (0,dist/* default */.ZP)(locale === "en" ? {
        url: "".concat("https://api.lamptan.co.th", "/v1/settings/contactUsEn"),
        method: "GET"
    } : null);
    const handleNewsletterSubscribe = async ()=>{
        const normalizedEmail = newsletterEmail.trim();
        const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);
        if (!isEmailValid) {
            toast({
                status: "error",
                title: t("layout.footer.subscribe.invalidEmail")
            });
            return;
        }
        try {
            setIsNewsletterLoading(true);
            await newsletter_repository/* NewsletterRepository.subscribe */.I.subscribe({
                email: normalizedEmail,
                tags: [
                    "footer-subscription"
                ]
            });
            setNewsletterEmail("");
            toast({
                status: "success",
                title: t("layout.footer.subscribe.success")
            });
        } catch (error) {
            toast({
                status: "error",
                title: t("layout.footer.subscribe.failed")
            });
        } finally{
            setIsNewsletterLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        height: "50px",
                        bgGradient: "linear-gradient(to right, #EC5E3A 10%, #F18556 60%, #F4A268 100%)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                            height: "inherit",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                color: "white",
                                height: "inherit",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                        href: "https://www.facebook.com/lamptanlighting/",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/image-icon/social-fb.png",
                                                alt: "facebook",
                                                width: 36,
                                                height: 36
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                        href: "https://liff.line.me/1645278921-kWRPP32q/?accountId=lamptan",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/image-icon/social-line.png",
                                                alt: "facebook",
                                                width: 36,
                                                height: 36
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                        href: "https://www.youtube.com/user/lamptan2001",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/image-icon/social-youtube.png",
                                                alt: "youtube",
                                                width: 36,
                                                height: 36
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                        href: "https://www.instagram.com/lamptan_official?igsh=MWd4YjVtMm91amNycw%3D%3D&utm_source=qr",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/image-icon/social-ig.png",
                                                alt: "instagram",
                                                width: 36,
                                                height: 36
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                        href: "https://www.tiktok.com/@lamptan_lighting?_t=8oTlB4rLjzl&_r=1",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/image-icon/social-tiktok.png",
                                                alt: "tiktok",
                                                width: 36,
                                                height: 36
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        ml: 3,
                                        display: {
                                            base: "none",
                                            lg: "block"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                            onSubmit: (event)=>{
                                                event.preventDefault();
                                                handleNewsletterSubscribe();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                spacing: 2,
                                                height: "42px",
                                                px: 4,
                                                borderRadius: "full",
                                                bg: "transparent",
                                                border: "2px solid",
                                                borderColor: "whiteAlpha.700",
                                                minW: {
                                                    lg: "340px",
                                                    xl: "400px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                        variant: "unstyled",
                                                        type: "email",
                                                        value: newsletterEmail,
                                                        onChange: (event)=>setNewsletterEmail(event.target.value),
                                                        placeholder: "Email",
                                                        color: "white",
                                                        fontSize: "lg",
                                                        _placeholder: {
                                                            color: "rgb(255 255 255 / 85%)"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                        type: "submit",
                                                        variant: "unstyled",
                                                        minW: "28px",
                                                        color: "white",
                                                        isLoading: isNewsletterLoading,
                                                        "aria-label": "subscribe",
                                                        fontSize: "22px",
                                                        lineHeight: 1,
                                                        children: "→"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                        children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            pt: 6,
                            pb: 10,
                            spacing: 6,
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                    width: "75%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                                            columns: 3,
                                            spacing: 6,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                            fontSize: "md",
                                                            mb: 3,
                                                            color: "primary.500",
                                                            textTransform: "uppercase",
                                                            children: t("layout.footer.menu1.title", {
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_LayoutFooterMenu, {
                                                            menu: menu1
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                            fontSize: "md",
                                                            mb: 3,
                                                            color: "primary.500",
                                                            textTransform: "uppercase",
                                                            children: t("layout.footer.menu2.title", {
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_LayoutFooterMenu, {
                                                            menu: menu2
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                            fontSize: "md",
                                                            mb: 3,
                                                            color: "primary.500",
                                                            textTransform: "uppercase",
                                                            children: t("layout.footer.menu3.title", {
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_LayoutFooterMenu, {
                                                            menu: menu3
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            bg: "#F4F4F4",
                                            p: 6,
                                            mt: 6,
                                            width: "66%",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                    size: "sm",
                                                    mb: 3,
                                                    children: t("layout.footer.subscribe.title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                    onSubmit: (event)=>{
                                                        event.preventDefault();
                                                        handleNewsletterSubscribe();
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                        spacing: 2,
                                                        borderBottom: "2px solid #444",
                                                        pb: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                                variant: "unstyled",
                                                                type: "email",
                                                                value: newsletterEmail,
                                                                onChange: (event)=>setNewsletterEmail(event.target.value),
                                                                placeholder: t("layout.footer.subscribe.placeholder")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                type: "submit",
                                                                variant: "unstyled",
                                                                minW: "auto",
                                                                isLoading: isNewsletterLoading,
                                                                "aria-label": "subscribe",
                                                                children: "→"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                    mt: 3,
                                                    fontSize: "sm",
                                                    color: "gray.600",
                                                    children: [
                                                        t("layout.footer.subscribe.consentPrefix"),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                                            href: "/privacy-policy",
                                                            color: "primary.500",
                                                            children: t("layout.footer.subscribe.consentLink")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                    width: "25%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                            fontSize: "md",
                                            mb: 3,
                                            color: "primary.500",
                                            textTransform: "uppercase",
                                            children: t("layout.footer.menu4.title", {
                                            })
                                        }),
                                        contactUsTh ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            mb: 0,
                                            className: "contact-us",
                                            dangerouslySetInnerHTML: {
                                                __html: contactUsTh.value
                                            }
                                        }) : null,
                                        contactUsEn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            mb: 0,
                                            className: "contact-us",
                                            dangerouslySetInnerHTML: {
                                                __html: contactUsEn.value
                                            }
                                        }) : null
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            pt: 7,
                            pb: {
                                base: "110px",
                                md: "110px",
                                lg: 10
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* Accordion */.UQ, {
                                    allowMultiple: true,
                                    defaultIndex: [
                                        0
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionItem */.Qd, {
                                            children: (param)=>/*#__PURE__*/ {
                                                let { isExpanded  } = param;
                                                return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
                                                            color: "primary.500",
                                                            py: 1,
                                                            textTransform: "uppercase",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                    flex: "1",
                                                                    textAlign: "left",
                                                                    children: t("layout.footer.menu1.title")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                                    boxSize: "22px",
                                                                    borderRadius: "full",
                                                                    bg: "gray.100",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: "/image-icon/".concat(isExpanded ? "minus-sm" : "plus-sm", ".png"),
                                                                        width: 18,
                                                                        height: 18,
                                                                        alt: "next"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                                                            pb: 4,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_LayoutFooterMenu, {
                                                                menu: menu1
                                                            })
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionItem */.Qd, {
                                            children: (param)=>/*#__PURE__*/ {
                                                let { isExpanded  } = param;
                                                return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
                                                            color: "primary.500",
                                                            py: 1,
                                                            textTransform: "uppercase",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                    flex: "1",
                                                                    textAlign: "left",
                                                                    children: t("layout.footer.menu2.title")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                                    boxSize: "22px",
                                                                    borderRadius: "full",
                                                                    bg: "gray.100",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: "/image-icon/".concat(isExpanded ? "minus-sm" : "plus-sm", ".png"),
                                                                        width: 18,
                                                                        height: 18,
                                                                        alt: "next"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                                                            pb: 4,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_LayoutFooterMenu, {
                                                                menu: menu2
                                                            })
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionItem */.Qd, {
                                            children: (param)=>/*#__PURE__*/ {
                                                let { isExpanded  } = param;
                                                return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
                                                            color: "primary.500",
                                                            py: 1,
                                                            textTransform: "uppercase",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                    flex: "1",
                                                                    textAlign: "left",
                                                                    children: t("layout.footer.menu3.title")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                                    boxSize: "22px",
                                                                    borderRadius: "full",
                                                                    bg: "gray.100",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: "/image-icon/".concat(isExpanded ? "minus-sm" : "plus-sm", ".png"),
                                                                        width: 18,
                                                                        height: 18,
                                                                        alt: "next"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                                                            pb: 4,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_LayoutFooterMenu, {
                                                                menu: menu3
                                                            })
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionItem */.Qd, {
                                            children: (param)=>/*#__PURE__*/ {
                                                let { isExpanded  } = param;
                                                return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
                                                            color: "primary.500",
                                                            py: 1,
                                                            textTransform: "uppercase",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                    flex: "1",
                                                                    textAlign: "left",
                                                                    children: t("layout.footer.menu4.title")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                                    boxSize: "22px",
                                                                    borderRadius: "full",
                                                                    bg: "gray.100",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: "/image-icon/".concat(isExpanded ? "minus-sm" : "plus-sm", ".png"),
                                                                        width: 18,
                                                                        height: 18,
                                                                        alt: "next"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                                                            pb: 4,
                                                            children: [
                                                                contactUsTh ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                    mb: 0,
                                                                    className: "contact-us",
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: contactUsTh.value
                                                                    }
                                                                }) : null,
                                                                contactUsEn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                    mb: 0,
                                                                    className: "contact-us",
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: contactUsEn.value
                                                                    }
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                    bg: "#F4F4F4",
                                    p: 4,
                                    mt: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                            size: "sm",
                                            mb: 3,
                                            children: t("layout.footer.subscribe.title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                            onSubmit: (event)=>{
                                                event.preventDefault();
                                                handleNewsletterSubscribe();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                spacing: 2,
                                                borderBottom: "2px solid #444",
                                                pb: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                        variant: "unstyled",
                                                        type: "email",
                                                        value: newsletterEmail,
                                                        onChange: (event)=>setNewsletterEmail(event.target.value),
                                                        placeholder: t("layout.footer.subscribe.placeholder")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                        type: "submit",
                                                        variant: "unstyled",
                                                        minW: "auto",
                                                        isLoading: isNewsletterLoading,
                                                        "aria-label": "subscribe",
                                                        children: "→"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                            mt: 3,
                                            fontSize: "sm",
                                            color: "gray.600",
                                            children: [
                                                t("layout.footer.subscribe.consentPrefix"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                                    href: "/privacy-policy",
                                                    color: "primary.500",
                                                    children: t("layout.footer.subscribe.consentLink")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                position: "fixed",
                bottom: currentScrollHeightPercentage < 95 ? "40px" : 350,
                right: 10,
                transition: "all 0.5s ease",
                display: {
                    base: "none",
                    xl: "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                    variant: "unstyled",
                    alignContent: "center",
                    alignItems: "center",
                    w: "150px",
                    height: "171px",
                    as: "a",
                    href: "https://liff.line.me/1645278921-kWRPP32q/?accountId=lamptan",
                    target: "_blank",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/LT-Mascot_Animed.gif",
                        width: 150,
                        height: 171,
                        alt: "chat",
                        unoptimized: true,
                        style: {
                            margin: "0 auto"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                position: "fixed",
                bottom: 0,
                left: "0",
                right: "0",
                bg: "#EADECE",
                zIndex: "overlay",
                pt: 4,
                pb: 3,
                boxShadow: "0px -1px 5px rgb(253 145 33 / 50%)",
                display: {
                    base: "block",
                    lg: "none"
                },
                className: "footer-mobile-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                    columns: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "unstyled",
                            height: "auto",
                            onClick: ()=>router.push("/"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        boxSize: "30px",
                                        position: "relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/image-icon/footer-home-icon.png",
                                            fill: true,
                                            style: {
                                                objectFit: "contain"
                                            },
                                            alt: "home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: locale === "th" ? "13px" : "11px",
                                        fontWeight: 300,
                                        mt: 1,
                                        textTransform: "uppercase",
                                        children: t("layout.footer.mobile.home", {
                                            // TH: หน้าแรก
                                            // EN: Home
                                            ns: "common"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "unstyled",
                            height: "auto",
                            onClick: ()=>router.push("/products?type=spacial-price"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        boxSize: "30px",
                                        position: "relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/image-icon/footer-sale-icon.png",
                                            fill: true,
                                            style: {
                                                objectFit: "contain"
                                            },
                                            alt: "sale"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: locale === "th" ? "13px" : "11px",
                                        fontWeight: 300,
                                        mt: 1,
                                        textTransform: "uppercase",
                                        children: t("layout.footer.mobile.sale", {
                                            // TH: โปรโมชั่น
                                            // EN: Promotion
                                            ns: "common"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "unstyled",
                            height: "auto",
                            onClick: ()=>router.push("/smart-home"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        boxSize: "30px",
                                        position: "relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/image-icon/footer-smart-home-icon.png",
                                            fill: true,
                                            style: {
                                                objectFit: "contain"
                                            },
                                            alt: "smart-home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: locale === "th" ? "13px" : "11px",
                                        fontWeight: 300,
                                        mt: 1,
                                        textTransform: "uppercase",
                                        children: t("layout.footer.mobile.smartHome", {
                                            // TH: สมาร์ทโฮม
                                            // EN: Smart Home
                                            ns: "common"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "unstyled",
                            height: "auto",
                            onClick: ()=>router.push("/decoration"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        boxSize: "30px",
                                        position: "relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/image-icon/footer-decoration-icon.png",
                                            fill: true,
                                            style: {
                                                objectFit: "contain"
                                            },
                                            alt: "decoration"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: locale === "th" ? "13px" : "11px",
                                        fontWeight: 300,
                                        mt: 1,
                                        textTransform: "uppercase",
                                        children: t("layout.footer.mobile.decoration", {
                                            // TH: โคมไฟตกแต่ง
                                            // EN: Decoration
                                            ns: "common"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "unstyled",
                            height: "auto",
                            as: "a",
                            href: "https://liff.line.me/1645278921-kWRPP32q/?accountId=lamptan",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        boxSize: "30px",
                                        position: "relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/image-icon/footer-chat-icon.png",
                                            fill: true,
                                            style: {
                                                objectFit: "contain"
                                            },
                                            alt: "chat"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: locale === "th" ? "13px" : "11px",
                                        fontWeight: 300,
                                        mt: 1,
                                        textTransform: "uppercase",
                                        children: t("layout.footer.mobile.chat", {
                                            // TH: แชท
                                            // EN: Chat
                                            ns: "common"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var footer_LayoutFooter = (LayoutFooter);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MenuOutlined.js
var MenuOutlined = __webpack_require__(53682);
// EXTERNAL MODULE: ./hooks/useProductCategories.ts
var useProductCategories = __webpack_require__(88062);
// EXTERNAL MODULE: ./hooks/useProductMainCategories.ts
var useProductMainCategories = __webpack_require__(68758);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/index.esm.js + 3 modules
var menu_dist_index_esm = __webpack_require__(5341);
// EXTERNAL MODULE: ./components/utils/UtilPriceFormatter.tsx
var UtilPriceFormatter = __webpack_require__(74046);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(83022);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js
var CheckOutlined = __webpack_require__(88284);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseOutlined.js
var CloseOutlined = __webpack_require__(28508);
// EXTERNAL MODULE: ./components/inputs/InputNumber.tsx
var InputNumber = __webpack_require__(55947);
// EXTERNAL MODULE: ./hooks/useCatchError.ts
var useCatchError = __webpack_require__(65633);
// EXTERNAL MODULE: ./hooks/useProductItem.ts
var useProductItem = __webpack_require__(13043);
// EXTERNAL MODULE: ./hooks/useUser.ts + 1 modules
var useUser = __webpack_require__(42409);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./respository/cart.repository.ts
var cart_repository = __webpack_require__(61015);
;// CONCATENATED MODULE: ./components/carts/MiniCartItem.tsx















function MiniCartItem(param) {
    let { item  } = param;
    // use i18n
    const { t  } = (0,useTranslation/* useTranslation */.$)([
        "common"
    ]);
    // use user
    const { user  } = (0,useUser/* default */.Z)();
    // use catch error
    const catchError = (0,useCatchError/* default */.Z)();
    // use cart
    const { cartItemDelete , cartItemQuantityUpdate  } = (0,useCart/* default */.Z)();
    // init cart remove loading
    const [isCartRemoveLoading, setIsCartRemoveLoading] = (0,react.useState)(false);
    // use router
    const router = (0,next_router.useRouter)();
    const { featuredImage , name: productName  } = (0,useProductItem/* default */.Z)({
        product: item.product,
        variation: item.variation
    });
    // init is remove cart item
    const [isRemoveCartItem, setIsRemoveCartItem] = (0,react.useState)(false);
    // init quantity
    const [quantity, setQuantity] = (0,react.useState)(item.quantity);
    (0,react.useEffect)(()=>{
        setQuantity(item.quantity);
    }, [
        item
    ]);
    // get variation name
    const variationName = (0,react.useMemo)(()=>{
        if (item.attributeOptions && item.attributeOptions.length > 0) {
            return item.attributeOptions.map((attributeOption)=>{
                return router.locale === "th" ? attributeOption.name_th : attributeOption.name_en;
            }).join(" ");
        }
        return "";
    }, [
        item.attributeOptions
    ]);
    const handleCartItemQuantityUpdate = async (key, quantity)=>{
        try {
            if (user && user.isAuthenticated) {
                await cart_repository/* CartRepository.updateQuantity */.e.updateQuantity({
                    key,
                    quantity
                });
            }
            cartItemQuantityUpdate(item.key, quantity);
        } catch (error) {
            catchError(error);
        }
    };
    const debouncedUpdateQuantity = (0,react.useRef)(user && user.isAuthenticated ? (0,lodash.debounce)(handleCartItemQuantityUpdate, 1000) : handleCartItemQuantityUpdate).current;
    const handleCartRemoveItem = async ()=>{
        try {
            setIsRemoveCartItem(true);
            setIsCartRemoveLoading(true);
            if (user && user.isAuthenticated) {
                await cart_repository/* CartRepository.removeItem */.e.removeItem(item.key);
            }
            cartItemDelete(item.key);
            setIsRemoveCartItem(false);
        } catch (error) {
            catchError(error);
        } finally{
            setIsCartRemoveLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        alignItems: "flex-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                boxSize: "60px",
                flex: "0 0 auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                    ratio: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: featuredImage,
                        alt: "featuredImage",
                        width: 60,
                        height: 60
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                flex: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        fontSize: "md",
                        fontWeight: 400,
                        textTransform: "uppercase",
                        mb: 1,
                        children: productName
                    }),
                    variationName !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSize: "sm",
                        mb: 1,
                        children: variationName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "xs",
                                children: t("form.label.quantity", {
                                    ns: "common"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                flex: "0 0 70px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
                                    size: "xs",
                                    step: 1,
                                    min: 1,
                                    max: item.maxQuantity,
                                    value: quantity,
                                    onChange: (valueAsString, valueAsNumber)=>{
                                        setQuantity(valueAsNumber);
                                        debouncedUpdateQuantity(item.key, valueAsNumber);
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                flex: "0 0 auto",
                justifySelf: "flex-end",
                textAlign: "right",
                children: [
                    isRemoveCartItem ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                        justifyContent: "flex-end",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                variant: "unstyled",
                                p: 0,
                                minW: "0",
                                height: "auto",
                                color: "primary.500",
                                isLoading: isCartRemoveLoading,
                                onClick: handleCartRemoveItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckOutlined/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                variant: "unstyled",
                                p: 0,
                                minW: "0",
                                height: "auto",
                                color: "gray.500",
                                onClick: ()=>{
                                    setIsRemoveCartItem(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                        variant: "unstyled",
                        p: 0,
                        minW: "0",
                        height: "auto",
                        onClick: ()=>{
                            setIsRemoveCartItem(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/image-icon/trash.png",
                            alt: "trash",
                            width: 13,
                            height: 18,
                            quality: "100"
                        })
                    }),
                    item.salePrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "sm",
                                color: "gray.500",
                                as: "s",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                    price: item.regularPrice
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontWeight: "500",
                                fontSize: "17px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                    price: item.salePrice
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontWeight: "500",
                        fontSize: "17px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                            price: item.regularPrice
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var carts_MiniCartItem = (MiniCartItem);

;// CONCATENATED MODULE: ./components/carts/MiniCart.tsx







function MiniCart() {
    // use i18n
    const { t  } = (0,useTranslation/* useTranslation */.$)([
        "common"
    ]);
    // get cart
    const { cart , cartSubTotal  } = (0,useCart/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        px: 3,
        py: 3,
        children: cart ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
                    spacing: 4,
                    mb: 4,
                    children: cart.items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(carts_MiniCartItem, {
                            item: item
                        }, index))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    borderBottom: "1px solid #eee",
                    mb: 3
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    textAlign: "center",
                    mb: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                children: t("miniCart.subTotal", {
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                color: "gray.800",
                                fontWeight: 400,
                                fontSize: "lg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                    price: cartSubTotal
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/cart",
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            fontWeight: 300,
                            fontSize: "20px",
                            borderRadius: "5px",
                            width: "100%",
                            as: "a",
                            children: t("miniCart.action.viewCart", {
                            })
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                children: t("miniCart.empty", {
                })
            })
        })
    });
}
/* harmony default export */ var carts_MiniCart = (MiniCart);

// EXTERNAL MODULE: ./hooks/useWishlist.ts
var useWishlist = __webpack_require__(56395);
;// CONCATENATED MODULE: ./components/layouts/header/LayoutHeaderCart.tsx









function LayoutHeaderCart(param) {
    let {} = param;
    var _cart_items;
    // use router
    const router = (0,next_router.useRouter)();
    // use cart
    const { cart  } = (0,useCart/* default */.Z)();
    // const use wish list
    const { wishlistsTotal  } = (0,useWishlist/* default */.Z)();
    // use media query
    const [isDesktop] = (0,media_query_dist_index_esm/* useMediaQuery */.ac)("(min-width: 992px)");
    // is allow show cart
    const isAllowShowCart = (0,react.useMemo)(()=>{
        var _cart_items;
        return cart && ((_cart_items = cart.items) === null || _cart_items === void 0 ? void 0 : _cart_items.length) > 0 && router.pathname !== "/cart" && router.pathname !== "/checkout" && router.pathname !== "/checkout/payment";
    }, [
        cart,
        router
    ]);
    // log cart
    (0,react.useEffect)(()=>{
        ;
    }, [
        cart
    ]);
    const cartTotalQuantity = cart ? (_cart_items = cart.items) === null || _cart_items === void 0 ? void 0 : _cart_items.filter((item)=>item.selected).reduce((acc, item)=>acc + item.quantity, 0) : 0;
    // log cartTotalQuantity
    (0,react.useEffect)(()=>{
        ;
    }, [
        cartTotalQuantity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/my-account/wishlists",
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                    variant: "link",
                    as: "a",
                    height: "30px",
                    minW: "20px",
                    position: "relative",
                    children: [
                        wishlistsTotal > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                            top: "-2px",
                            right: "-4px",
                            position: "absolute",
                            bg: "red",
                            color: "white",
                            width: "16px",
                            height: "16px",
                            borderRadius: "full",
                            fontSize: 10,
                            zIndex: 1,
                            children: wishlistsTotal >= 10 ? "9+" : wishlistsTotal
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/image-icon/".concat(isDesktop ? "wishlist-active.png" : "wishlist.png"),
                            width: 25,
                            height: 24,
                            alt: "wishlist"
                        })
                    ]
                })
            }),
            isAllowShowCart && isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* Menu */.v2, {
                placement: "bottom-end",
                children: (param)=>/*#__PURE__*/ {
                    let { isOpen  } = param;
                    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuButton */.j2, {
                                height: "30px",
                                minW: "20px",
                                position: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/image-icon/".concat(isDesktop ? "shopping-bag-white.png" : "shopping-bag.png"),
                                        width: 20,
                                        height: 24,
                                        alt: "cart"
                                    }),
                                    cartTotalQuantity > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        top: "-1px",
                                        right: "-11px",
                                        position: "absolute",
                                        bg: "red",
                                        color: "white",
                                        width: "16px",
                                        height: "16px",
                                        borderRadius: "full",
                                        fontSize: 10,
                                        zIndex: 1,
                                        children: cartTotalQuantity
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuList */.qy, {
                                minW: "150px",
                                border: "0",
                                borderRadius: 0,
                                bg: "transparent",
                                boxShadow: "none",
                                pt: "10px",
                                mr: "-25px",
                                color: "gray.800",
                                w: "320px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                    position: "relative",
                                    boxShadow: "0px 2px 8px rgb(0 0 0 / 30%)",
                                    bg: "white",
                                    py: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            width: "30px",
                                            height: "18px",
                                            position: "absolute",
                                            top: "-18px",
                                            right: "21px",
                                            overflow: "hidden",
                                            boxShadow: "0 16px 10px -17px rgba(0, 0, 0, 0.5)",
                                            _after: {
                                                content: '""',
                                                width: "15px",
                                                height: "18px",
                                                bg: "white",
                                                position: "absolute",
                                                transform: "rotate(45deg)",
                                                top: "10px",
                                                left: "7.5px",
                                                boxShadow: "-1px -1px 10px -2px rgba(0, 0, 0, 0.5)"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(carts_MiniCart, {})
                                    ]
                                })
                            })
                        ]
                    });
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/cart",
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                    variant: "link",
                    as: "a",
                    height: "30px",
                    minW: "20px",
                    position: "relative",
                    children: [
                        cartTotalQuantity > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                            top: "-1px",
                            right: "-11px",
                            position: "absolute",
                            bg: "red",
                            color: "white",
                            width: "16px",
                            height: "16px",
                            borderRadius: "full",
                            fontSize: 10,
                            zIndex: 1,
                            children: cartTotalQuantity
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/image-icon/".concat(isDesktop ? "shopping-bag-white.png" : "shopping-bag.png"),
                            width: 20,
                            height: 24,
                            alt: "cart"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var header_LayoutHeaderCart = (LayoutHeaderCart);

// EXTERNAL MODULE: ./store/wishlist.store.ts
var wishlist_store = __webpack_require__(4295);
;// CONCATENATED MODULE: ./components/layouts/header/LayoutHeaderMember.tsx








function LayoutHeaderMember(param) {
    let {} = param;
    // use router
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common"
    ]);
    // use media query
    const [isDesktop] = (0,media_query_dist_index_esm/* useMediaQuery */.ac)("(min-width: 1024px)");
    // use auth
    const { user , logout  } = (0,useUser/* default */.Z)();
    // use cart
    const { cartClear  } = (0,useCart/* default */.Z)();
    // use wish list store
    const { setWishlists , setWishlistsTotal  } = (0,wishlist_store/* useWishlistStore */.Y)();
    return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* Menu */.v2, {
            placement: "bottom",
            children: (param)=>{
                let { isOpen  } = param;
                return !user || !user.isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuButton */.j2, {
                            padding: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                spacing: 0,
                                pt: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        flex: "0 0 auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/image-icon/user-icon-white.png",
                                            width: 26,
                                            height: 26,
                                            alt: "wishlist"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        as: "span",
                                        fontWeight: 300,
                                        children: t("layout.header.member.login", {
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuList */.qy, {
                            minW: "150px",
                            border: "0",
                            borderRadius: 0,
                            bg: "transparent",
                            boxShadow: "none",
                            pt: "13px",
                            color: "gray.800",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                position: "relative",
                                boxShadow: "0px 2px 8px rgb(0 0 0 / 30%)",
                                bg: "white",
                                py: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        width: "30px",
                                        height: "18px",
                                        position: "absolute",
                                        top: "-18px",
                                        left: "50%",
                                        marginLeft: "-15px",
                                        overflow: "hidden",
                                        boxShadow: "0 16px 10px -17px rgba(0, 0, 0, 0.5)",
                                        _after: {
                                            content: '""',
                                            width: "15px",
                                            height: "18px",
                                            bg: "white",
                                            position: "absolute",
                                            transform: "rotate(45deg)",
                                            top: "10px",
                                            left: "7.5px",
                                            boxShadow: "-1px -1px 10px -2px rgba(0, 0, 0, 0.5)"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                        onClick: ()=>{
                                            router.push("/login", "/login", {
                                                locale: router.locale
                                            });
                                        },
                                        justifyContent: "center",
                                        textAlign: "center",
                                        _hover: {
                                            bg: "white",
                                            color: "primary.500"
                                        },
                                        _focus: {
                                            bg: "white",
                                            color: "primary.500"
                                        },
                                        transition: "all 0.2s",
                                        children: t("layout.header.member.menu.login", {
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                        onClick: ()=>{
                                            router.push("/register", "/register", {
                                                locale: router.locale
                                            });
                                        },
                                        justifyContent: "center",
                                        textAlign: "center",
                                        _hover: {
                                            bg: "white",
                                            color: "primary.500"
                                        },
                                        _focus: {
                                            bg: "white",
                                            color: "primary.500"
                                        },
                                        transition: "all 0.2s",
                                        children: t("layout.header.member.menu.register", {
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuButton */.j2, {
                            padding: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                pt: "4px",
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        pt: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/image-icon/user-icon-white.png",
                                            width: 32,
                                            height: 32,
                                            alt: "wishlist"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: "18px",
                                        maxW: "100px",
                                        noOfLines: 1,
                                        children: user === null || user === void 0 ? void 0 : user.firstName
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuList */.qy, {
                            minW: "150px",
                            border: "0",
                            borderRadius: 0,
                            bg: "transparent",
                            boxShadow: "none",
                            pt: "10px",
                            color: "gray.800",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                position: "relative",
                                boxShadow: "0px 0px 6px rgb(0 0 0 / 20%)",
                                bg: "white",
                                py: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        width: "30px",
                                        height: "18px",
                                        position: "absolute",
                                        top: "-18px",
                                        left: "50%",
                                        marginLeft: "-15px",
                                        overflow: "hidden",
                                        boxShadow: "0 16px 10px -17px rgba(0, 0, 0, 0.5)",
                                        _after: {
                                            content: '""',
                                            width: "15px",
                                            height: "18px",
                                            bg: "white",
                                            position: "absolute",
                                            transform: "rotate(45deg)",
                                            top: "10px",
                                            left: "7.5px",
                                            boxShadow: "-1px -1px 10px -2px rgba(0, 0, 0, 0.5)"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                        onClick: ()=>{
                                            router.push("/my-account/details", "/my-account/details", {
                                                locale: router.locale
                                            });
                                        },
                                        justifyContent: "center",
                                        textAlign: "center",
                                        _hover: {
                                            bg: "white",
                                            color: "primary.500"
                                        },
                                        _focus: {
                                            bg: "white",
                                            color: "primary.500"
                                        },
                                        transition: "all 0.2s",
                                        children: t("layout.header.member.menu.my-account", {
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                        justifyContent: "center",
                                        textAlign: "center",
                                        onClick: async ()=>{
                                            await logout();
                                            cartClear();
                                            setWishlists([]);
                                            setWishlistsTotal(0);
                                            router.push("/", "/", {
                                                locale: router.locale
                                            });
                                        },
                                        _hover: {
                                            bg: "white",
                                            color: "primary.500"
                                        },
                                        _focus: {
                                            bg: "white",
                                            color: "primary.500"
                                        },
                                        transition: "all 0.2s",
                                        children: t("layout.header.member.menu.logout", {
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
            variant: "unstyled",
            color: "#EADED3",
            onClick: ()=>{
                if (user && user.isAuthenticated) {
                    router.push("/my-account", "/my-account", {
                        locale: router.locale
                    });
                } else {
                    router.push("/login", "/login", {
                        locale: router.locale
                    });
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        maxW: "100px",
                        noOfLines: 1,
                        children: user && user.isAuthenticated ? user === null || user === void 0 ? void 0 : user.firstName : t("layout.header.member.login")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/image-icon/user-icon-bg.png",
                            width: 30,
                            height: 30,
                            alt: "user"
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var header_LayoutHeaderMember = (LayoutHeaderMember);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LeftOutlined.js
var LeftOutlined = __webpack_require__(37653);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/RightOutlined.js
var RightOutlined = __webpack_require__(43929);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 51 modules
var modal_dist_index_esm = __webpack_require__(26117);
// EXTERNAL MODULE: ./hooks/useProductCategoriesArchive.ts
var useProductCategoriesArchive = __webpack_require__(58696);
;// CONCATENATED MODULE: ./components/layouts/header/LayoutHeaderMenuMobile.tsx









function LayoutHeaderMenuMobile(param) {
    let { open , onClosed  } = param;
    var _currentChildCategory__mainCategory, _prevChildCategory_find, _prevChildCategory_find1, _prevChildCategory_find2, _prevChildCategory_find3, _prevChildCategory_find4, _prevChildCategory_find5, _productMainCategories_find, _productMainCategories_find1, _productMainCategories_find2, _productMainCategories_find3, _productMainCategories_find4, _currentChildCategory__mainCategory1, _currentChildCategory__mainCategory2, _currentChildCategory__mainCategory3, _currentChildCategory__mainCategory4, _currentChildCategory__mainCategory5;
    const { t  } = (0,useTranslation/* useTranslation */.$)([
        "common"
    ]);
    const { isOpen , onOpen , onClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)({
        isOpen: open
    });
    const { productMainCategories  } = (0,useProductMainCategories/* default */.Z)();
    const { productCategories , productCategoryTree , productCategoriesTreeForLighting , productCategoriesTreeForSmartHome , productCategoriesTreeForDecorationLampStyle , productCategoriesTreeForDecorationLampFunction , currentParentCategoryIndexes , productCategoriesSelectedIds , handleCategorySelected , handleSetCurrentParentCategoryIndexes , handleClearFilter  } = (0,useProductCategoriesArchive/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { locale  } = router;
    // curent child category
    const [currentChildCategory, setCurrentChildCategory] = react.useState([]);
    // prev child category
    const [prevChildCategory, setPrevChildCategory] = react.useState([]);
    // current menu item
    const [currentMenuItem, setCurrentMenuItem] = react.useState([]);
    // predefined decoration lamp top level category
    const decorationLampTopLevelCategory = [
        {
            id: 1000,
            name_th: "สไตล์",
            name_en: "Style",
            parentId: null,
            mainCategoryId: 3,
            mainCategory: productMainCategories.find((m)=>m.id === 3),
            permalink: "/decoration-lamp/?productType=decoration",
            sequence: "01",
            createdAt: new Date(),
            updatedAt: new Date(),
            children: productCategoriesTreeForDecorationLampStyle
        },
        {
            id: 1001,
            name_th: "การใช้งาน",
            name_en: "Function",
            parentId: null,
            mainCategoryId: 3,
            mainCategory: productMainCategories.find((m)=>m.id === 3),
            permalink: "/decoration-lamp/?productType=decoration",
            sequence: "02",
            createdAt: new Date(),
            updatedAt: new Date(),
            children: productCategoriesTreeForDecorationLampFunction
        }
    ];
    // handle parent category click
    const handleParentCategoryClick = (category)=>{
        ;
        if (category.permalink === "lighting") {
            const topLevelChildCategory = productCategoriesTreeForLighting;
            ;
            if (topLevelChildCategory && topLevelChildCategory.length > 0) {
                setCurrentChildCategory(topLevelChildCategory);
            }
        } else if (category.permalink === "smart-home") {
            const topLevelChildCategory1 = productCategoriesTreeForSmartHome;
            ;
            if (topLevelChildCategory1 && topLevelChildCategory1.length > 0) {
                setCurrentChildCategory(topLevelChildCategory1);
            }
        } else if (category.permalink === "decoration-lamp") {
            const topLevelChildCategory2 = decorationLampTopLevelCategory;
            ;
            if (topLevelChildCategory2 && topLevelChildCategory2.length > 0) {
                setCurrentChildCategory(topLevelChildCategory2);
            }
        }
    };
    const handleChildCategoryClick = (0,react.useCallback)((category)=>{
        if (category.children && category.children.length > 0) {
            setCurrentChildCategory(category.children);
            setPrevChildCategory(currentChildCategory);
            setCurrentMenuItem([
                ...currentMenuItem,
                category
            ]);
        } else {
            var _productMainCategories_find;
            // close drawer
            onClose();
            onClosed();
            router.push("/product-categories/".concat((_productMainCategories_find = productMainCategories.find((m)=>m.id === category.mainCategoryId)) === null || _productMainCategories_find === void 0 ? void 0 : _productMainCategories_find.permalink, "/").concat(category === null || category === void 0 ? void 0 : category.permalink));
        }
    }, [
        currentChildCategory,
        onClosed,
        productMainCategories,
        router
    ]);
    const handleClose = ()=>{
        onClose();
        onClosed();
        // reset current child category
        setCurrentChildCategory([]);
        // reset prev child category
        setPrevChildCategory([]);
        // reset current menu item
        setCurrentMenuItem([]);
    };
    ;
    ;
    ;
    const lastCurrentMenuItem = currentMenuItem[currentMenuItem.length - 1];
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Drawer */.dy, {
        isOpen: isOpen,
        placement: "left",
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerOverlay */.P1, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerContent */.sc, {
                maxW: "85%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* DrawerBody */.Ng, {
                    bg: "#EADECE",
                    p: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            bg: "#000",
                            py: 3,
                            px: 5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/lamptan-logo.png",
                                        alt: "logo",
                                        width: 140,
                                        height: 30
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerCloseButton */.cC, {
                                    color: "white"
                                })
                            ]
                        }),
                        currentChildCategory && currentChildCategory.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    variant: "unstyled",
                                    width: "100%",
                                    height: "auto",
                                    onClick: ()=>{
                                        ;
                                        ;
                                        currentMenuItem.pop();
                                        ;
                                        if (lastCurrentMenuItem && lastCurrentMenuItem.id === 1) {
                                            const topLevelChildCategory = productCategories.filter((c)=>c.mainCategoryId === 1 && !c.parentId);
                                            ;
                                            if (productCategoriesTreeForLighting) {
                                                setCurrentChildCategory(productCategoriesTreeForLighting);
                                            }
                                        } else {
                                            if (!currentChildCategory[0].parentId && prevChildCategory) {
                                                setCurrentChildCategory([]);
                                                setPrevChildCategory([]);
                                            } else if (currentChildCategory && currentChildCategory.length > 0 && prevChildCategory && prevChildCategory.length > 0 && currentChildCategory.length === prevChildCategory.length && currentChildCategory[0].parentId === prevChildCategory[0].parentId) {
                                                setCurrentChildCategory([]);
                                                setPrevChildCategory([]);
                                            } else if (prevChildCategory && prevChildCategory.length > 0) {
                                                setCurrentChildCategory(prevChildCategory);
                                            } else {
                                                setCurrentChildCategory([]);
                                                setPrevChildCategory([]);
                                            }
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                        borderBottom: "1px solid #cdcdcd",
                                        py: 3,
                                        px: 5,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                borderRadius: "full",
                                                bg: "white",
                                                boxSize: "30px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftOutlined/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                children: [
                                                    currentChildCategory && currentChildCategory[0].mainCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                        flex: "0 0 30px",
                                                        w: "30px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: currentChildCategory[0].mainCategory.id === 1 ? "/image-icon/lighting-icon.png" : currentChildCategory[0].mainCategory.id === 2 ? "/image-icon/smart-home-icon.png" : "/image-icon/decoration-icon.png",
                                                            width: currentChildCategory[0].mainCategory.id === 1 ? 18 : ((_currentChildCategory__mainCategory = currentChildCategory[0].mainCategory) === null || _currentChildCategory__mainCategory === void 0 ? void 0 : _currentChildCategory__mainCategory.id) === 2 ? 26 : 22,
                                                            height: 30,
                                                            alt: "icon"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                        textTransform: "uppercase",
                                                        children: lastCurrentMenuItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: locale === "th" ? lastCurrentMenuItem.name_th : lastCurrentMenuItem.name_en && lastCurrentMenuItem.name_en === "Lighting" ? "Lighting & Electric Devices" : lastCurrentMenuItem.name_en === "Smart Home" ? "Smart Home Solution" : lastCurrentMenuItem.name_en
                                                        }) : currentChildCategory && currentChildCategory[0] && prevChildCategory && prevChildCategory.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            textTransform: "uppercase",
                                                            children: ((_prevChildCategory_find = prevChildCategory.find((c)=>c.id === currentChildCategory[0].parentId)) === null || _prevChildCategory_find === void 0 ? void 0 : _prevChildCategory_find.name_th) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: locale === "th" ? (_prevChildCategory_find1 = prevChildCategory.find((c)=>c.id === currentChildCategory[0].parentId)) === null || _prevChildCategory_find1 === void 0 ? void 0 : _prevChildCategory_find1.name_th : ((_prevChildCategory_find2 = prevChildCategory.find((c)=>c.id === currentChildCategory[0].parentId)) === null || _prevChildCategory_find2 === void 0 ? void 0 : _prevChildCategory_find2.name_en) && ((_prevChildCategory_find3 = prevChildCategory.find((c)=>c.id === currentChildCategory[0].parentId)) === null || _prevChildCategory_find3 === void 0 ? void 0 : _prevChildCategory_find3.name_en) === "Lighting" ? "Lighting & Electric Devices" : ((_prevChildCategory_find4 = prevChildCategory.find((c)=>c.id === currentChildCategory[0].parentId)) === null || _prevChildCategory_find4 === void 0 ? void 0 : _prevChildCategory_find4.name_en) === "Smart Home" ? "Smart Home Solution" : (_prevChildCategory_find5 = prevChildCategory.find((c)=>c.id === currentChildCategory[0].parentId)) === null || _prevChildCategory_find5 === void 0 ? void 0 : _prevChildCategory_find5.name_en
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: locale === "th" ? (_productMainCategories_find = productMainCategories.find((m)=>m.id === currentChildCategory[0].mainCategoryId)) === null || _productMainCategories_find === void 0 ? void 0 : _productMainCategories_find.name_th : ((_productMainCategories_find1 = productMainCategories.find((m)=>m.id === currentChildCategory[0].mainCategoryId)) === null || _productMainCategories_find1 === void 0 ? void 0 : _productMainCategories_find1.name_en) && ((_productMainCategories_find2 = productMainCategories.find((m)=>m.id === currentChildCategory[0].mainCategoryId)) === null || _productMainCategories_find2 === void 0 ? void 0 : _productMainCategories_find2.name_en) === "Lighting" ? "Lighting & Electric Devices" : ((_productMainCategories_find3 = productMainCategories.find((m)=>m.id === currentChildCategory[0].mainCategoryId)) === null || _productMainCategories_find3 === void 0 ? void 0 : _productMainCategories_find3.name_en) === "Smart Home" ? "Smart Home Solution" : (_productMainCategories_find4 = productMainCategories.find((m)=>m.id === currentChildCategory[0].mainCategoryId)) === null || _productMainCategories_find4 === void 0 ? void 0 : _productMainCategories_find4.name_en
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            textTransform: "uppercase",
                                                            children: locale === "th" ? currentChildCategory && ((_currentChildCategory__mainCategory1 = currentChildCategory[0].mainCategory) === null || _currentChildCategory__mainCategory1 === void 0 ? void 0 : _currentChildCategory__mainCategory1.name_th) : currentChildCategory && ((_currentChildCategory__mainCategory2 = currentChildCategory[0].mainCategory) === null || _currentChildCategory__mainCategory2 === void 0 ? void 0 : _currentChildCategory__mainCategory2.name_en) === "Lighting" ? "Lighting & Electric Devices" : currentChildCategory && ((_currentChildCategory__mainCategory3 = currentChildCategory[0].mainCategory) === null || _currentChildCategory__mainCategory3 === void 0 ? void 0 : _currentChildCategory__mainCategory3.name_en) === "Smart Home" ? "Smart Home Solution" : currentChildCategory && ((_currentChildCategory__mainCategory4 = currentChildCategory[0].mainCategory) === null || _currentChildCategory__mainCategory4 === void 0 ? void 0 : _currentChildCategory__mainCategory4.name_en) && ((_currentChildCategory__mainCategory5 = currentChildCategory[0].mainCategory) === null || _currentChildCategory__mainCategory5 === void 0 ? void 0 : _currentChildCategory__mainCategory5.name_en)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    variant: "unstyled",
                                    width: "100%",
                                    height: "auto",
                                    onClick: ()=>{
                                        if (lastCurrentMenuItem) {
                                            var _lastCurrentMenuItem_mainCategory;
                                            if ((_lastCurrentMenuItem_mainCategory = lastCurrentMenuItem.mainCategory) === null || _lastCurrentMenuItem_mainCategory === void 0 ? void 0 : _lastCurrentMenuItem_mainCategory.permalink) {
                                                var _lastCurrentMenuItem_mainCategory1;
                                                router.push("/product-categories/".concat((_lastCurrentMenuItem_mainCategory1 = lastCurrentMenuItem.mainCategory) === null || _lastCurrentMenuItem_mainCategory1 === void 0 ? void 0 : _lastCurrentMenuItem_mainCategory1.permalink, "/").concat(lastCurrentMenuItem === null || lastCurrentMenuItem === void 0 ? void 0 : lastCurrentMenuItem.permalink));
                                            } else {
                                                router.push("/product-categories/".concat(lastCurrentMenuItem === null || lastCurrentMenuItem === void 0 ? void 0 : lastCurrentMenuItem.permalink));
                                            }
                                        } else {
                                            if (currentChildCategory[0]) {
                                                if (currentChildCategory[0].mainCategory) {
                                                    if (!currentChildCategory[0].parentId) {
                                                        var _currentChildCategory__mainCategory;
                                                        router.push("/product-categories/".concat((_currentChildCategory__mainCategory = currentChildCategory[0].mainCategory) === null || _currentChildCategory__mainCategory === void 0 ? void 0 : _currentChildCategory__mainCategory.permalink));
                                                    } else if (currentChildCategory[0].mainCategoryId === 2) {
                                                        // smart home
                                                        router.push("/product-categories/".concat(currentChildCategory[0].mainCategory.permalink));
                                                    } else if (currentChildCategory[0].mainCategoryId === 3) {
                                                        // decoration
                                                        router.push("/product-categories/".concat(currentChildCategory[0].mainCategory.permalink));
                                                    } else {
                                                        router.push("/product-categories/".concat(currentChildCategory[0].mainCategory.permalink, "/").concat(currentChildCategory[0].permalink));
                                                    }
                                                } else {
                                                    var _currentChildCategory_;
                                                    router.push("/product-categories/".concat((_currentChildCategory_ = currentChildCategory[0]) === null || _currentChildCategory_ === void 0 ? void 0 : _currentChildCategory_.permalink));
                                                }
                                            } else {
                                                router.push("/product-categories");
                                            }
                                        }
                                        onClose();
                                        onClosed();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                                        borderBottom: "1px solid #cdcdcd",
                                        py: 3,
                                        px: 5,
                                        justifyContent: "space-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            textTransform: currentChildCategory.length > 0 && currentChildCategory[0].parentId ? "capitalize" : "uppercase",
                                            children: t("layout.header.mobileMenu.all")
                                        })
                                    })
                                }),
                                currentChildCategory.map((category, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        variant: "unstyled",
                                        width: "100%",
                                        height: "auto",
                                        onClick: ()=>{
                                            handleChildCategoryClick(category);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                            borderBottom: "1px solid #cdcdcd",
                                            py: 3,
                                            px: 5,
                                            justifyContent: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                    textTransform: currentChildCategory.length > 0 && currentChildCategory[0].parentId ? "capitalize" : "uppercase",
                                                    children: locale === "th" ? category.name_th : category.name_en
                                                }),
                                                category.children && category.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                    borderRadius: "full",
                                                    bg: "white",
                                                    boxSize: "30px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightOutlined/* default */.Z, {})
                                                })
                                            ]
                                        }, index)
                                    }, index);
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: productMainCategories.map((category, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    variant: "unstyled",
                                    width: "100%",
                                    height: "auto",
                                    onClick: ()=>{
                                        handleParentCategoryClick(category);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                        borderBottom: "1px solid #cdcdcd",
                                        py: 3,
                                        px: 5,
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                        flex: "0 0 30px",
                                                        w: "30px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: category.id === 1 ? "/image-icon/lighting-icon.png" : category.id === 2 ? "/image-icon/smart-home-icon.png" : "/image-icon/decoration-icon.png",
                                                            width: category.id === 1 ? 18 : category.id === 2 ? 26 : 22,
                                                            height: 30,
                                                            alt: "icon"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                        textTransform: "uppercase",
                                                        children: locale === "th" ? category.name_th : category.name_en && category.name_en === "Lighting" ? "Lighting & Electric Devices" : category.name_en === "Smart Home" ? "Smart Home Solution" : category.name_en
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                borderRadius: "full",
                                                bg: "white",
                                                boxSize: "28px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightOutlined/* default */.Z, {})
                                            })
                                        ]
                                    }, index)
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var header_LayoutHeaderMenuMobile = (LayoutHeaderMenuMobile);

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./components/layouts/header/LayoutHeaderSearchInput.tsx






function LayoutHeaderSearchInput() {
    // use react hook form
    const { register , setValue , handleSubmit  } = (0,react_hook_form_dist_index_esm/* useForm */.cI)();
    // use router
    const router = (0,next_router.useRouter)();
    const handleSearchSubmit = (data)=>{
        ;
        if (data.search) {
            router.push("/search?query=".concat(data.search));
        }
        return;
    };
    (0,react.useEffect)(()=>{
        ;
        // set search value
        if (router.query.query) {
            setValue("search", router.query.query);
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        position: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit(handleSearchSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                    borderRadius: "3xl",
                    size: "sm",
                    bg: "white",
                    color: "gray.800",
                    border: "0",
                    height: "30px",
                    ...register("search")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    height: "100%",
                    zIndex: 2,
                    variant: "unstyled",
                    pr: 2,
                    display: "inline-flex",
                    type: "submit",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/image-icon/search.png",
                        width: 19,
                        height: 20,
                        alt: "search"
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var header_LayoutHeaderSearchInput = (LayoutHeaderSearchInput);

;// CONCATENATED MODULE: ./components/layouts/header/LayoutHeaderTopbar.tsx




function LayoutHeaderTopbar() {
    const router = (0,next_router.useRouter)();
    // convert locale to real language
    const localeFormatted = router.locale === "th" ? "ไทย" : "ENGLISH";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        bgGradient: "linear-gradient(to right, #F15A38 10%, #F9A868 70%)",
        position: "relative",
        zIndex: "dropdown",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
            maxW: "1440",
            px: 6,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* Menu */.v2, {
                        placement: "bottom",
                        children: (param)=>/*#__PURE__*/ {
                            let { isOpen  } = param;
                            return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuButton */.j2, {
                                        padding: 0,
                                        height: "30px",
                                        color: "white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/image-icon/".concat(router.locale, "-flag.png"),
                                                        alt: "th",
                                                        width: 18,
                                                        height: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    children: localeFormatted
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                    position: "relative",
                                                    top: "1px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/image-icon/dropdown-white.png",
                                                        width: "8",
                                                        height: "6",
                                                        alt: "dropdown"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuList */.qy, {
                                        minW: "100px",
                                        border: "0",
                                        boxShadow: "0px 0px 6px rgb(0 0 0 / 20%)",
                                        borderRadius: 0,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                width: "30px",
                                                height: "18px",
                                                position: "absolute",
                                                top: "-18px",
                                                left: "50%",
                                                marginLeft: "-15px",
                                                overflow: "hidden",
                                                boxShadow: "0 16px 10px -17px rgba(0, 0, 0, 0.5)",
                                                _after: {
                                                    content: '""',
                                                    width: "15px",
                                                    height: "18px",
                                                    bg: "white",
                                                    position: "absolute",
                                                    transform: "rotate(45deg)",
                                                    top: "10px",
                                                    left: "7.5px",
                                                    boxShadow: "-1px -1px 10px -2px rgba(0, 0, 0, 0.5)"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                onClick: ()=>{
                                                    router.push(router.asPath, router.asPath, {
                                                        locale: "th"
                                                    });
                                                },
                                                _hover: {
                                                    bg: router.locale === "th" ? "primary.50" : "gray.50"
                                                },
                                                _focus: {
                                                    bg: router.locale === "th" ? "primary.50" : "gray.50"
                                                },
                                                backgroundColor: router.locale === "th" ? "primary.50" : "white",
                                                isDisabled: router.locale === "th",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/image-icon/th-flag.png",
                                                                alt: "th",
                                                                width: 20,
                                                                height: 20
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            children: router.locale === "th" ? "ไทย" : "THAI"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                onClick: ()=>{
                                                    router.push(router.asPath, router.asPath, {
                                                        locale: "en"
                                                    });
                                                },
                                                _hover: {
                                                    bg: router.locale === "en" ? "primary.50" : "gray.50"
                                                },
                                                _focus: {
                                                    bg: router.locale === "en" ? "primary.50" : "gray.50"
                                                },
                                                backgroundColor: router.locale === "en" ? "primary.50" : "white",
                                                isDisabled: router.locale === "en",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/image-icon/en-flag.png",
                                                                alt: "th",
                                                                width: 20,
                                                                height: 20
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            children: "ENGLISH"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var header_LayoutHeaderTopbar = (LayoutHeaderTopbar);

;// CONCATENATED MODULE: ./components/layouts/header/LayoutHeader.tsx















function LayoutHeader() {
    var _productMainCategories_find, _productMainCategories_find1, _productMainCategories_find2, _productMainCategories_find3;
    const { productCategoryTree  } = (0,useProductCategories/* default */.Z)();
    const { productMainCategories  } = (0,useProductMainCategories/* default */.Z)();
    const [mobileMenuOpen, setMobileMenuOpen] = (0,react.useState)(false);
    const { locale  } = (0,next_router.useRouter)();
    const { t  } = (0,useTranslation/* useTranslation */.$)([
        "common"
    ]);
    const categoriesMenu1 = (0,react.useMemo)(()=>{
        if (productCategoryTree && productCategoryTree.length > 0) {
            if (productCategoryTree[0].children && productCategoryTree[0].children.length > 0) {
                return productCategoryTree[0].children.filter((category, index)=>index <= 12);
            }
        }
        return [];
    }, [
        productCategoryTree
    ]);
    const categoriesMenu2 = (0,react.useMemo)(()=>{
        if (productCategoryTree && productCategoryTree.length > 0) {
            if (productCategoryTree[0].children && productCategoryTree[0].children.length > 0) {
                return productCategoryTree[0].children.filter((category, index)=>index > 12 && index <= 34);
            }
        }
        return [];
    }, [
        productCategoryTree
    ]);
    const categoriesMenu3 = (0,react.useMemo)(()=>{
        if (productCategoryTree && productCategoryTree.length > 0) {
            if (productCategoryTree[0].children && productCategoryTree[0].children.length > 0) {
                return productCategoryTree[0].children.filter((category, index)=>index > 40);
            }
        }
        return [];
    }, [
        productCategoryTree
    ]);
    const categoriesMenu4 = (0,react.useMemo)(()=>{
        if (productCategoryTree && productCategoryTree.length > 0) {
            if (productCategoryTree[1].children && productCategoryTree[1].children.length > 0) {
                return productCategoryTree[1].children.filter((category, index)=>index <= 20 && category.mainCategoryId !== 3);
            }
        }
        return [];
    }, [
        productCategoryTree
    ]);
    const categoriesMenu5 = (0,react.useMemo)(()=>{
        if (productCategoryTree && productCategoryTree.length > 0) {
            if (productCategoryTree[2].children && productCategoryTree[2].children.length > 0) {
                return productCategoryTree[2].children.filter((category, index)=>index <= 3);
            }
        }
        return [];
    }, [
        productCategoryTree
    ]);
    const categoriesMenu6 = (0,react.useMemo)(()=>{
        if (productCategoryTree && productCategoryTree.length > 0) {
            if (productCategoryTree[2].children && productCategoryTree[2].children.length > 0) {
                return productCategoryTree[2].children.filter((category, index)=>index > 3);
            }
        }
        return [];
    }, [
        productCategoryTree
    ]);
    const categoriesMenu7 = (0,react.useMemo)(()=>{
        if (productCategoryTree && productCategoryTree.length > 0) {
            if (productCategoryTree[3].children && productCategoryTree[3].children.length > 0) {
                return productCategoryTree[3].children;
            }
        }
        return [];
    }, [
        productCategoryTree
    ]);
    ;
    const renderMenu = (categories)=>{
        const menu = categories;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* List */.aV, {
            color: "gray.800",
            fontSize: "sm",
            fontWeight: "300",
            children: menu.map((item)=>{
                var _productMainCategories_find;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(index_esm/* ListItem */.HC, {
                    py: "2.5px",
                    textTransform: "initial",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/product-categories/".concat((_productMainCategories_find = productMainCategories.find((m)=>m.id === item.mainCategoryId)) === null || _productMainCategories_find === void 0 ? void 0 : _productMainCategories_find.permalink, "/").concat(item === null || item === void 0 ? void 0 : item.permalink),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                _hover: {
                                    textDecoration: "none",
                                    color: "primary.500"
                                },
                                children: locale === "th" ? item === null || item === void 0 ? void 0 : item.name_th : item === null || item === void 0 ? void 0 : item.name_en
                            })
                        }),
                        (item === null || item === void 0 ? void 0 : item.children) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* List */.aV, {
                            color: "gray.800",
                            fontWeight: "300",
                            ml: "20px",
                            children: item === null || item === void 0 ? void 0 : item.children.map((child)=>{
                                var _productMainCategories_find;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                                    py: "2.5px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/product-categories/".concat((_productMainCategories_find = productMainCategories.find((m)=>m.id === item.mainCategoryId)) === null || _productMainCategories_find === void 0 ? void 0 : _productMainCategories_find.permalink, "/").concat(child === null || child === void 0 ? void 0 : child.permalink),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                            _hover: {
                                                textDecoration: "none",
                                                color: "primary.500"
                                            },
                                            children: locale === "th" ? child === null || child === void 0 ? void 0 : child.name_th : child === null || child === void 0 ? void 0 : child.name_en
                                        })
                                    })
                                }, child === null || child === void 0 ? void 0 : child.id);
                            })
                        })
                    ]
                }, item === null || item === void 0 ? void 0 : item.id);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LayoutHeaderTopbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                position: "relative",
                zIndex: "150",
                bg: "#363437",
                height: "72px",
                display: {
                    base: "none",
                    lg: "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                    maxW: "1160px",
                    px: 6,
                    h: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                        spacing: 0,
                        color: "white",
                        h: "100%",
                        pt: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                    height: "100%",
                                    pl: 0,
                                    pr: {
                                        base: 0,
                                        md: 6,
                                        lg: 8,
                                        xl: 14
                                    },
                                    flex: "0 0 auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/lamptan-logo-new.png",
                                        alt: "logo",
                                        width: 140,
                                        height: 30
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                bg: "#363437",
                                height: "100%",
                                flex: 1,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        flex: 1,
                                        pr: 4,
                                        height: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* List */.aV, {
                                            display: "flex",
                                            justifyContent: "space-around",
                                            className: "main-menu",
                                            fontSize: {
                                                xl: locale === "th" ? "lg" : "md"
                                            },
                                            fontWeight: "400",
                                            height: "100%",
                                            gap: 4,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* ListItem */.HC, {
                                                    className: "category-menu-item",
                                                    height: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    textTransform: "uppercase",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/",
                                                            passHref: true,
                                                            legacyBehavior: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                                                _hover: {
                                                                    textDecoration: "none"
                                                                },
                                                                children: t("layout.header.navigation.lighting")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                            className: "category-menu-dropdown",
                                                            p: 5,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                    width: "30px",
                                                                    height: "18px",
                                                                    position: "absolute",
                                                                    top: "-18px",
                                                                    left: "120px",
                                                                    overflow: "hidden",
                                                                    boxShadow: "0 16px 10px -17px rgba(0, 0, 0, 0.5)",
                                                                    _after: {
                                                                        content: '""',
                                                                        width: "15px",
                                                                        height: "18px",
                                                                        bg: "white",
                                                                        position: "absolute",
                                                                        transform: "rotate(45deg)",
                                                                        top: "10px",
                                                                        left: "7.5px",
                                                                        boxShadow: "-1px -1px 10px -2px rgba(0, 0, 0, 0.5)"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                                                                    columns: 4,
                                                                    spacing: 5,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                                                    color: "primary.500",
                                                                                    borderBottom: "2px solid",
                                                                                    fontSize: "lg",
                                                                                    fontWeight: "400",
                                                                                    mb: 2,
                                                                                    pb: 1,
                                                                                    textTransform: "uppercase",
                                                                                    children: productCategoryTree && productCategoryTree.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: "/product-categories/".concat((_productMainCategories_find = productMainCategories.find((m)=>m.id === productCategoryTree[0].mainCategoryId)) === null || _productMainCategories_find === void 0 ? void 0 : _productMainCategories_find.permalink, "/").concat(productCategoryTree[0].permalink),
                                                                                        children: locale === "th" ? productCategoryTree[0].name_th : productCategoryTree[0].name_en
                                                                                    })
                                                                                }),
                                                                                renderMenu(categoriesMenu1 ? categoriesMenu1 : [])
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                            children: renderMenu(categoriesMenu2 ? categoriesMenu2 : [])
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                                                    color: "primary.500",
                                                                                    borderBottom: "2px solid",
                                                                                    fontSize: "lg",
                                                                                    fontWeight: "400",
                                                                                    mb: 2,
                                                                                    pb: 1,
                                                                                    textTransform: "uppercase",
                                                                                    children: productCategoryTree && productCategoryTree.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: "/product-categories/".concat((_productMainCategories_find1 = productMainCategories.find((m)=>m.id === productCategoryTree[0].mainCategoryId)) === null || _productMainCategories_find1 === void 0 ? void 0 : _productMainCategories_find1.permalink, "/").concat(productCategoryTree[1].permalink),
                                                                                        children: locale === "th" ? productCategoryTree[1].name_th : productCategoryTree[1].name_en
                                                                                    })
                                                                                }),
                                                                                renderMenu(categoriesMenu4 ? categoriesMenu4 : []),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                                                    color: "primary.500",
                                                                                    borderBottom: "2px solid",
                                                                                    fontSize: "lg",
                                                                                    fontWeight: "400",
                                                                                    mb: 2,
                                                                                    pb: 1,
                                                                                    mt: 2,
                                                                                    textTransform: "uppercase",
                                                                                    children: productCategoryTree && productCategoryTree.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: "/product-categories/".concat((_productMainCategories_find2 = productMainCategories.find((m)=>m.id === productCategoryTree[0].mainCategoryId)) === null || _productMainCategories_find2 === void 0 ? void 0 : _productMainCategories_find2.permalink, "/").concat(productCategoryTree[2].permalink),
                                                                                        children: locale === "th" ? productCategoryTree[2].name_th : productCategoryTree[2].name_en
                                                                                    })
                                                                                }),
                                                                                renderMenu(categoriesMenu5 ? categoriesMenu5 : [])
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                            children: [
                                                                                renderMenu(categoriesMenu6 ? categoriesMenu6 : []),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                                                    color: "primary.500",
                                                                                    borderBottom: "2px solid",
                                                                                    fontSize: "lg",
                                                                                    fontWeight: "400",
                                                                                    mb: 2,
                                                                                    pb: 1,
                                                                                    mt: 2,
                                                                                    textTransform: "uppercase",
                                                                                    children: productCategoryTree && productCategoryTree.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: "/product-categories/".concat((_productMainCategories_find3 = productMainCategories.find((m)=>m.id === productCategoryTree[0].mainCategoryId)) === null || _productMainCategories_find3 === void 0 ? void 0 : _productMainCategories_find3.permalink, "/").concat(productCategoryTree[3].permalink),
                                                                                        children: locale === "th" ? productCategoryTree[3].name_th : productCategoryTree[3].name_en
                                                                                    })
                                                                                }),
                                                                                renderMenu(categoriesMenu7 ? categoriesMenu7 : [])
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                                                    height: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    textTransform: "uppercase",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/smart-home",
                                                        passHref: true,
                                                        legacyBehavior: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                                            _hover: {
                                                                textDecoration: "none"
                                                            },
                                                            children: t("layout.header.navigation.smartHome")
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                                                    height: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    textTransform: "uppercase",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/decoration",
                                                        passHref: true,
                                                        legacyBehavior: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                                            _hover: {
                                                                textDecoration: "none"
                                                            },
                                                            children: t("layout.header.navigation.decoration")
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        flex: "0 0 180px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LayoutHeaderSearchInput, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        flex: "0 0 auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LayoutHeaderMember, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        flex: "0 0 auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LayoutHeaderCart, {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                display: {
                    base: "block",
                    lg: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        bg: "gray.800",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                py: 2,
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/lamptan-logo.png",
                                                alt: "logo",
                                                width: 120,
                                                height: 40
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LayoutHeaderMember, {})
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        bg: "secondary.500",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                py: 2,
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        flex: "0 0 auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                            variant: "unstyled",
                                            px: 0,
                                            py: 0,
                                            fontSize: "2xl",
                                            lineHeight: 1,
                                            minW: "auto",
                                            height: "auto",
                                            onClick: ()=>{
                                                setMobileMenuOpen(true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOutlined/* default */.Z, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        flex: "1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LayoutHeaderSearchInput, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        flex: "0 0 auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LayoutHeaderCart, {})
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LayoutHeaderMenuMobile, {
                open: mobileMenuOpen,
                onClosed: ()=>{
                    setMobileMenuOpen(false);
                }
            })
        ]
    });
}
/* harmony default export */ var header_LayoutHeader = (LayoutHeader);

;// CONCATENATED MODULE: ./layouts/RootLayout.tsx






function RootLayout(param) {
    let { children , showFooter =true , ...rest } = param;
    // use router
    const router = (0,next_router.useRouter)();
    const className = router.asPath.replace(/\//g, "-").replace(/^-/, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        flexDirection: "column",
        ...rest,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LayoutHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                minH: "300px",
                children: children
            }),
            showFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                className: "layout-footer-warpper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_LayoutFooter, {})
            })
        ]
    });
}
/* harmony default export */ var layouts_RootLayout = (RootLayout);


/***/ }),

/***/ 64232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70594);

// Create axios instance with default config
const _axios = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.lamptan.co.th"
});
// Set default headers
_axios.defaults.headers.common.Authorization = "";
// Map to store pending requests
const pendingRequests = new Map();
// Request interceptor
_axios.interceptors.request.use((config)=>{
    if (config.headers) {
        config.headers["x-custom-lang"] = "th";
    }
    ;
    const requestIdentifier = "".concat(config.url, "_").concat(config.method);
    // Cancel previous request with the same identifier
    if (pendingRequests.has(requestIdentifier)) {
        var _pendingRequests_get;
        (_pendingRequests_get = pendingRequests.get(requestIdentifier)) === null || _pendingRequests_get === void 0 ? void 0 : _pendingRequests_get.abort();
    }
    // Create new AbortController for this request
    const controller = new AbortController();
    config.signal = controller.signal;
    pendingRequests.set(requestIdentifier, controller);
    return config;
}, (error)=>Promise.reject(error));
// Response interceptor
_axios.interceptors.response.use((response)=>{
    const { config , data  } = response;
    ;
    // Remove completed request from pending map
    const requestIdentifier = "".concat(config.url, "_").concat(config.method);
    pendingRequests.delete(requestIdentifier);
    return response;
}, (error)=>{
    // Remove failed request from pending map
    if (error.config) {
        const requestIdentifier = "".concat(error.config.url, "_").concat(error.config.method);
        pendingRequests.delete(requestIdentifier);
    }
    return Promise.reject(error);
});
/* harmony default export */ __webpack_exports__["Z"] = (_axios);


/***/ }),

/***/ 61015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ CartRepository; }
/* harmony export */ });
/* harmony import */ var libs_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64232);

class CartRepository {
    static findOne() {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/v1/public/cart");
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static addItems(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/public/cart/add-items", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static addOrUpdateItemToCart(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/public/cart/add-item", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static removeItem(key) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("/v1/public/cart/remove-item/".concat(key));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static updateQuantity(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/public/cart/update-item-quantity", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static itemSelectUpdate(key, isSelected) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/public/cart/items/".concat(key, "/select"), {
                    selected: isSelected
                });
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static updateShippingMethod(shippingMethodId) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/public/cart/shipping-methods/".concat(shippingMethodId));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static updateShippingAddress(addressId) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/public/cart/shipping-address/".concat(addressId));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static updateBillingAddress(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/public/cart/billing-address", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static validateBeforeCheckout() {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/public/cart");
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static applyCoupon(code) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/public/coupon/apply", {
                    code
                });
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static removeCoupon(id) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/public/coupon/".concat(id, "/remove"));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static validateCoupon() {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/public/coupon/validate");
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    constructor(){}
}


/***/ }),

/***/ 70625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ NewsletterRepository; }
/* harmony export */ });
/* harmony import */ var libs_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64232);

class NewsletterRepository {
    static async subscribe(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/auth/newsletter/subscribe", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    constructor(){}
}


/***/ }),

/***/ 39098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useCartStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(782);


const useCartStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)((set)=>({
        cart: null,
        setCart: (payload)=>set({
                cart: payload
            }),
        setQuantity: (key, quantity)=>set((state)=>({
                    cart: state.cart ? {
                        ...state.cart,
                        items: state.cart.items.map((item)=>item.key === key ? {
                                ...item,
                                quantity: quantity
                            } : item)
                    } : null
                }))
    }), {
    name: "cart-storage",
    storage: (0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .createJSONStorage */ .FL)(()=>localStorage)
}));


/***/ }),

/***/ 4295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useWishlistStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

const useWishlistStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        wishlists: [],
        wishlistsTotal: 0,
        createWishlist: (payload)=>set(()=>({
                    wishlists: [
                        payload
                    ]
                })),
        addWishlist: (payload)=>set((state)=>({
                    wishlists: [
                        ...state.wishlists,
                        payload
                    ]
                })),
        deleteWishlist: (id)=>set((state)=>({
                    wishlists: state.wishlists.filter((wishlist)=>wishlist.id !== id)
                })),
        setWishlists: (payload)=>set(()=>({
                    wishlists: payload
                })),
        setWishlistsTotal: (payload)=>set(()=>({
                    wishlistsTotal: payload
                }))
    }));


/***/ })

}]);